import React, { useEffect, useState, useContext, useRef, useLayoutEffect } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import { DraggableElement } from "../../components/workflow/DraggableElement";
import DroppableArea from "../../components/workflow/DroppableArea";
import { BsThreeDots } from "react-icons/bs";
import { toast } from "../../utils/toast";
import Modal from "./PreviewModal/Modal";
import DynamicPage from "./DynamicPage";
import { useLocation, useNavigate } from "react-router-dom";
import ValidationModal from "./ValidationModal";
import CompareValidationModal from "./CompareValidationModal";
import WorkflowVersions from "./WorkflowVersions";
import { cloneWorkflow } from "../../service/workflow";
import AppContext from "../../context/AppContext";
import ExitModal from "./ExitModal/ExitModal";
import {
  getElements,
  Translations,
  ASPECT_RATIOS,
  SAFETY_DISALLOWED_FIELD_TYPES,
} from "./constants";
import { Parameters } from "./constants";
import { Elements } from "./constants";
import Joyride from "react-joyride";
import { createWorkflow } from "../../service/workflow";
import {
  createSafetyWorkflow,
  updateSafetyWorkflow,
  deleteSafetyWorkflow,
  fetchSafetyWorkflowData,
} from "../../service/workflow";
import { uploadFileToS3 } from "../../service/S3Bucket";
import { fetchWorkflowHistory } from "../../service/workflow";
import { updateWorkflow } from "../../service/workflow";
import { getField, getFieldNames } from "../../service/workflow";
import FieldDetails from "./FieldDetails";
import CloneOption from "./CloneOption";
import { GetFieldFolder } from "./GetFieldFolder/GetFieldFolder";
import { MandatoryField } from "./MandatoryField/MandatoryField";
import { Spinner } from "../../Spinner";
import CommonButton from "../../components/common/CommonButton";
import ActionIconButton from "../../components/common/ActionIconButton";
import translations from "../../components/common/Translations";
import BackButton from "../../components/common/BackButton";
import FieldInfoIcon from "../../components/common/FieldInfoIcon";
import {
  findItemRecursive,
  mapFieldsSanitizeVisibilityRules,
  removeVisibilityRuleCondition,
  renameVisibilityRuleExpectedValue,
  toggleVisibilityCondition,
  updateNestedItemByUniqueKey,
  visibilityRulesWithLegacySeed,
} from "../../utils/workflowVisibilityRules";
import {
  isCompareEligibleField,
  flattenWorkflowFields,
  removeCompareValidationsTargeting,
  upsertCompareValidation,
} from "../../utils/workflowCompareValidation";
import {
  getLinkedWorkflowRules,
  hydrateLinkedWorkflowRules,
  mapFieldsSanitizeLinkedWorkflowRules,
  removeLinkedWorkflowRulesForOption,
  renameLinkedWorkflowExpectedValue,
  setLinkedWorkflowForOption,
  validateLinkedWorkflowRules,
  applyLinkedWorkflowMarkers,
  buildLinkedWorkflowMarkerFields,
  splitLinkedWorkflowMarkerFields,
  stripLinkedWorkflowMarkerFields,
} from "../../utils/workflowLinkedWorkflowRules";
import { getWorkflowListByProjectId } from "../../service/User";
import {
  Pencil,
  X,
  CloudUpload,
  Eye,
  Check,
  ChevronDown,
  Plus,
  FileCheck2,
  Search,
  Copy,
  History,
  Trash2,
  ShieldCheck,
} from "lucide-react";
import { Menu, Transition } from "@headlessui/react";
import DeletePermission from "../../components/suspence/DeletePermission";
import { isRTL } from "../../utils/rtl";

// Stable identity so DroppableArea's useDrop isn't rebuilt on every render.
const NO_DISALLOWED_FIELD_TYPES = [];

const DynamicWorkFlow = () => {
  const {
    selectedOrgId,
    theme,
    langMode,
    workflowmaker,
    runTour,
    handleJoyrideCallback,
    projectId,
  } = useContext(AppContext);
  const [isNewFieldDragged, setIsNewFieldDragged] = useState(false);
  const isRtl = isRTL(langMode);
  const [isloading, setIsLoading] = useState(false);
  const elements = getElements(langMode);
  const [parameters, setParameters] = useState(Parameters);
  // Canvas state is held per builder target: the main workflow and the optional
  // safety-compliance sub-workflow each keep their own fields, pages and selection.
  // The `droppedItems`/`dragItems`/... aliases further down point at whichever one
  // is currently being edited, so every existing handler keeps working unchanged.
  const [mainDroppedItems, setMainDroppedItems] = useState([]);
  const [safetyDroppedItems, setSafetyDroppedItems] = useState([]);
  const [openTab, setOpenTab] = useState(1);
  const [elSearch, setElSearch] = useState("");
  const [collapsedElementCats, setCollapsedElementCats] = useState({
    basic: false,
    selection: false,
    media: false,
  });
  const [mainTab, setMainTab] = useState(1);
  const [showInput, setShowInput] = useState(false);
  const [inputValues, setInputValues] = useState([]);
  const [nextId, setNextId] = useState(1);
  const [savedItems, setSavedItems] = useState([]);
  const [mainPreview, setMainPreview] = useState({
    fieldType: "",
  });
  const [safetyPreview, setSafetyPreview] = useState({
    fieldType: "",
  });
  const [mainDragItems, setMainDragItems] = useState([]);
  const [safetyDragItems, setSafetyDragItems] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [tempInputValue, setTempInputValue] = useState({});
  const [tempEditValues, setTempEditValues] = useState({});
  const [isEditShow, setIsEditShow] = useState("");
  const [mainRadioButtons, setMainRadioButtons] = useState([]);
  const [safetyRadioButtons, setSafetyRadioButtons] = useState([]);
  const [workflowName, setworkflowName] = useState("");
  const [maxAllowedAccuracy, setMaxAllowedAccuracy] = useState(null); // update by harshit
  const [reportField, setreportField] = useState(false);
  const [reportInput, setreportInput] = useState("");
  const [pdfInput, setPdfInput] = useState("");
  const [showRadioOptions, setShowRadioOptions] = useState(true);
  const [selectedRadioOption, setSelectedRadioOption] = useState();
  const [mainPage, setMainPage] = useState(1);
  const [safetyPage, setSafetyPage] = useState(1);
  // Highest page number that has ever existed this session (via load/add/duplicate) -- unlike
  // deriving from dragItems alone, this doesn't "forget" an empty page the moment you navigate
  // away from it (an empty page has no items, so it leaves no trace in dragItems by itself).
  const [mainMaxPage, setMainMaxPage] = useState(1);
  const [safetyMaxPage, setSafetyMaxPage] = useState(1);
  // Deleted-row ids are also per canvas: they go to /workflow/update for the main
  // workflow and to /safety-workflow/update for the child, so mixing them would
  // send one form's ids to the other's endpoint.
  const [mainFieldIdsToBeDeleted, setMainFieldIdsToBeDeleted] = useState([]);
  const [safetyFieldIdsToBeDeleted, setSafetyFieldIdsToBeDeleted] = useState([]);
  const [mainRadioValueIdsToBeDeleted, setMainRadioValueIdsToBeDeleted] =
    useState([]);
  const [safetyRadioValueIdsToBeDeleted, setSafetyRadioValueIdsToBeDeleted] =
    useState([]);
  const [mainValidationIdsToBeDeleted, setMainValidationIdsToBeDeleted] =
    useState([]);
  const [safetyValidationIdsToBeDeleted, setSafetyValidationIdsToBeDeleted] =
    useState([]);
  const [collapsedGroups, setCollapsedGroups] = useState({});
  const [collapse, setCollapse] = useState(false);
  const [accountProtection, setAccountProtectionCheck] = useState(true);
  const [isPageWise, setIsPageWise] = useState(false);
  // ------- sakshi -------- start
  const [isReviewEnabled, setIsReviewEnabled] = useState(false);
  // ------- sakshi -------- end
  // Show the distance between the coordinates uploaded with the task and the
  // coordinates captured when the field user submitted, in report/PDF exports.
  const [isShowDistance, setIsShowDistance] = useState(false);
  // Safety compliance: when on, task completion is gated behind a safety-checklist
  // sub-workflow, built on the same canvas (see `builderTarget`) but with a
  // restricted palette. The child is a separate backend row (`safetyWorkflowId`).
  const [isSafetyComplianceRequired, setIsSafetyComplianceRequired] =
    useState(false);
  const [builderTarget, setBuilderTarget] = useState("main");
  const [safetyWorkflowName, setSafetyWorkflowName] = useState("");
  const [safetyWorkflowId, setSafetyWorkflowId] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [title, setTitle] = useState("");
  const [selectedRadioId, setSelectedRadioId] = useState(null);
  const [taskExcelColumns, setTaskExcelColumns] = useState([]);
  // Company stamp image uploaded with the workflow (create/update multipart part).
  const [companyStamp, setCompanyStamp] = useState(null);
  const [companyStampPreview, setCompanyStampPreview] = useState("");
  const [showStampModal, setShowStampModal] = useState(false);
  // Header "Add Fields For Report" / "Select Mandatory Field" modals (moved up from CloneOption so their trigger buttons can sit in the header).
  const [fields, setFields] = useState([]);
  const [manfields, setManFields] = useState(null);
  const [open, setOpen] = useState(false);
  const [manopen, setManOpen] = useState(false);
  // Header "Workflow settings" panel — purely visual, defaults open to match the fields' old always-visible behavior.
  const [settingsOpen, setSettingsOpen] = useState(true);
  const [showDeletePageConfirm, setShowDeletePageConfirm] = useState(false);
  const [showDeleteSafetyConfirm, setShowDeleteSafetyConfirm] = useState(false);

  // --- Active-canvas aliases -------------------------------------------------
  // Everything below this point reads/writes the canvas through these names, so the
  // whole builder (palette drop, field details, preview, page nav) transparently
  // edits either the main workflow or the safety sub-workflow. Payload assembly
  // deliberately does NOT use them -- it reads the `main*`/`safety*` state directly.
  const isSafetyTarget =
    isSafetyComplianceRequired && builderTarget === "safety";
  const droppedItems = isSafetyTarget ? safetyDroppedItems : mainDroppedItems;
  const setDroppedItems = isSafetyTarget
    ? setSafetyDroppedItems
    : setMainDroppedItems;
  const dragItems = isSafetyTarget ? safetyDragItems : mainDragItems;
  const setDragItems = isSafetyTarget ? setSafetyDragItems : setMainDragItems;
  const radioButtons = isSafetyTarget ? safetyRadioButtons : mainRadioButtons;
  const setRadioButtons = isSafetyTarget
    ? setSafetyRadioButtons
    : setMainRadioButtons;
  const preview = isSafetyTarget ? safetyPreview : mainPreview;
  const setPreview = isSafetyTarget ? setSafetyPreview : setMainPreview;
  const page = isSafetyTarget ? safetyPage : mainPage;
  const setPage = isSafetyTarget ? setSafetyPage : setMainPage;
  const maxPage = isSafetyTarget ? safetyMaxPage : mainMaxPage;
  const setMaxPage = isSafetyTarget ? setSafetyMaxPage : setMainMaxPage;
  const setfieldIdsToBeDeleted = isSafetyTarget
    ? setSafetyFieldIdsToBeDeleted
    : setMainFieldIdsToBeDeleted;
  const setradioValueIdsToBeDeleted = isSafetyTarget
    ? setSafetyRadioValueIdsToBeDeleted
    : setMainRadioValueIdsToBeDeleted;
  const setValidationsDeleteId = isSafetyTarget
    ? setSafetyValidationIdsToBeDeleted
    : setMainValidationIdsToBeDeleted;
  // Unsaved-work guards look across both canvases, not just the visible one.
  const builderFieldCount =
    mainDragItems.length +
    mainDroppedItems.length +
    safetyDragItems.length +
    safetyDroppedItems.length;
  // ---------------------------------------------------------------------------

  const location = useLocation();
  const { isClone } = location.state || {};
  const { isEdit } = location.state || {};
  const [timerValue, setTimerValue] = useState(
    Array.from({ length: 11 }, (_, i) => (i + 1) * 5),
  );
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [selectedTimer, setSelectedTimer] = useState(30);
  const [workflowVersionHistories, setWorkflowVersionHistories] = useState([]);
  const [showVersions, setShowVersions] = useState(false);
  const [validationId, setValidationId] = useState(1);
  const [validationModal, setValidationModal] = useState(false);
  const [compareValidationModal, setCompareValidationModal] = useState(false);
  const [pdficon, setPdfIcon] = useState(false);
  const [reporticon, setReportIcon] = useState(false);
  const [size] = useState(5);
  const [pages, setPages] = useState(0);
  const [exitModal, setExitModal] = useState(false);
  // Workflows a field option may link to, for the Linked Workflow picker.
  const [linkedWorkflowOptions, setLinkedWorkflowOptions] = useState([]);
  const [linkedWorkflowsLoading, setLinkedWorkflowsLoading] = useState(false);
  const computeIsOptionShow = (items) => {
    const stack = Array.isArray(items) ? [...items] : [];
    while (stack.length) {
      const item = stack.pop();
      if (!item) continue;
      if (item.isOptionShow === true) return true;
      if (
        Array.isArray(item.radioInputValues) &&
        item.radioInputValues.length
      ) {
        stack.push(...item.radioInputValues);
      }
    }
    return false;
  };

  const {
    workflowId,
    workflowFields,
    existWorkflowName,
    existPdfTitleName,
    workflowTimer,
    existDragItems,
    existRadioButtons,
    accountProtectionCheck,
    clockin,
    clockout,
    isPageWise: existIsPageWise,
    // ------- sakshi -------- start
    isReviewEnabled: existIsReviewEnabled,
    // ------- sakshi -------- end
    isShowDistance: existIsShowDistance,
    isSafetyComplianceRequired: existIsSafetyComplianceRequired,
    safetySourceWorkflowId,
    maxAllowedAccuracydata,
    existCompanyStamp,
  } = location.state || {};

  useEffect(() => {
    if (isEdit) {
      setworkflowName(existWorkflowName);
      // update by harshit -- start
      if (typeof maxAllowedAccuracydata === "number") {
        setMaxAllowedAccuracy(maxAllowedAccuracydata);
      }
      // update by harshit -- end
      setTitle(existPdfTitleName);
      setSelectedTimer(workflowTimer);
      setPdfInput(preview.excelReportName);
      setreportInput(preview.reportName);
      setAccountProtectionCheck(accountProtectionCheck);
      if (clockin) {
        setSelectedOption("clockin");
      } else if (clockout) {
        setSelectedOption("clockout");
      } else {
        setSelectedOption(null); // fallback if neither is true
      }
    }
  }, [
    isEdit,
    existWorkflowName,
    existPdfTitleName,
    preview.excelReportName,
    preview.reportName,
    accountProtectionCheck,
    clockin,
    clockout,
    maxAllowedAccuracydata, // update by harshit
  ]);

  useEffect(() => {
    if (isClone) {
      setPdfInput(preview.excelReportName);
      setreportInput(preview.reportName);
    }
  }, [isClone, preview.excelReportName, preview.reportName]);

  useEffect(() => {
    if ((isEdit || isClone) && existCompanyStamp) {
      setCompanyStampPreview(existCompanyStamp);
    }
  }, [isEdit, isClone, existCompanyStamp]);

  // Initialize the page-wise toggle once from the source workflow (edit/clone)
  useEffect(() => {
    if (isEdit || isClone) {
      setIsPageWise(Boolean(existIsPageWise));
    } else {
      setIsPageWise(true);
    }
  }, [isEdit, isClone, existIsPageWise]);

  // ------- sakshi -------- start
  useEffect(() => {
    if (isEdit || isClone) {
      setIsReviewEnabled(Boolean(existIsReviewEnabled));
    } else {
      setIsReviewEnabled(false);
    }
  }, [isEdit, isClone, existIsReviewEnabled]);
  // ------- sakshi -------- end

  // Initialize the show-distance toggle once from the source workflow (edit/clone)
  useEffect(() => {
    if (isEdit || isClone) {
      setIsShowDistance(Boolean(existIsShowDistance));
    } else {
      setIsShowDistance(false);
    }
  }, [isEdit, isClone, existIsShowDistance]);

  useEffect(() => {
    if (isEdit || isClone) {
      setIsSafetyComplianceRequired(Boolean(existIsSafetyComplianceRequired));
    } else {
      setIsSafetyComplianceRequired(false);
    }
  }, [isEdit, isClone, existIsSafetyComplianceRequired]);

  // The safety form is its own backend row, so get-workflow-metadata doesn't carry
  // it -- fetch it separately for the workflow we're editing (or cloning from).
  // A workflow with no safety form answers 607, which the service maps to null.
  useEffect(() => {
    const sourceWorkflowId = isEdit ? workflowId : safetySourceWorkflowId;
    if (!sourceWorkflowId) return;

    let cancelled = false;
    (async () => {
      try {
        const data = await fetchSafetyWorkflowData(sourceWorkflowId);
        if (cancelled || !data) return;

        const { markerFields: safetyMarkers, normalFields: safetyFields } =
          splitLinkedWorkflowMarkerFields(data.safetyFields ?? []);
        const safetyDragItems = stripLinkedWorkflowMarkerFields(
          data.safetyDragItems ?? []
        );
        const sourceFields = safetyDragItems?.length
          ? hydrateLinkedWorkflowRules(safetyDragItems, safetyFields)
          : safetyFields ?? [];
        const seededFromMarkers = applyLinkedWorkflowMarkers(
          sourceFields,
          safetyMarkers
        );
        // A clone must post its safety form as a brand-new child, so drop the
        // source's primary keys and start unlinked.
        const seededFields = isClone
          ? removeIds(seededFromMarkers)
          : seededFromMarkers;
        setSafetyWorkflowId(isClone ? null : data.safetyWorkflowId);
        setSafetyWorkflowName(data.safetyWorkflowName ?? "");
        setSafetyDroppedItems(seededFields);
        setSafetyDragItems(seededFields);
        setSafetyRadioButtons(isClone ? [] : data.safetyRadioButtons);
        setSafetyMaxPage(
          Math.max(
            1,
            ...seededFields
              .map((item) => Number(item?.page) || 1)
              .filter((value) => Number.isFinite(value)),
          ),
        );
      } catch (err) {
        console.error("Error fetching safety workflow:", err);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [isEdit, isClone, workflowId, safetySourceWorkflowId]);

  // The workflow a field option can link to must be an active workflow of the
  // same project. get-workflow-list is already scoped that way and drops static
  // and safety sub-workflows, so the only exclusion left to the UI is the
  // workflow being saved -- a workflow cannot link itself, and offering it would
  // only surface as a rejected save. On clone the row being written is brand new,
  // so the source workflow stays a valid target.
  const openWorkflowId = isEdit ? workflowId : null;

  useEffect(() => {
    if (!projectId) {
      setLinkedWorkflowOptions([]);
      return undefined;
    }

    let cancelled = false;
    setLinkedWorkflowsLoading(true);
    (async () => {
      try {
        const list = await getWorkflowListByProjectId(projectId);
        if (cancelled) return;
        setLinkedWorkflowOptions(
          (Array.isArray(list) ? list : [])
            .filter(
              (item) =>
                openWorkflowId == null ||
                Number(item.workflowId) !== Number(openWorkflowId),
            )
            .map((item) => ({
              value: item.workflowId,
              label: item.workflowName || `Workflow ${item.workflowId}`,
            })),
        );
      } catch (err) {
        if (!cancelled) setLinkedWorkflowOptions([]);
        console.error("Error fetching linkable workflow list:", err);
      } finally {
        if (!cancelled) setLinkedWorkflowsLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [projectId, openWorkflowId]);

  // When page-wise is disabled, collapse everything onto a single page so new
  useEffect(() => {
    if (!isPageWise) {
      setMainPage(1);
      setSafetyPage(1);
    }
  }, [isPageWise]);

  //update prevw
  const prevPreviewRef = useRef(preview);
  const prevDropItems = useRef(droppedItems);
  useEffect(() => {
    const prev = prevPreviewRef.current;
    const isChanged = JSON.stringify(prev) !== JSON.stringify(preview);

    if (isChanged) {
      console.log("?? Preview changed:", preview);
      prevPreviewRef.current = preview;
    }

    if (!preview?.uniqueKey) return;

    const matchedItem = droppedItems.find(
      (item) => item.uniqueKey === preview.uniqueKey,
    );
    if (!matchedItem) return;

    const updateItems = droppedItems.map((item) => {
      if (item.uniqueKey === preview.uniqueKey) {
        return {
          ...item,
          fieldType: preview.fieldType,
        };
      }
      return item; // don't forget to return unchanged items too
    });

    setDroppedItems(updateItems);
  }, [preview]);

  useEffect(() => {
    const prev = prevDropItems.current;
    const isChanged = JSON.stringify(prev) !== JSON.stringify(droppedItems);
    if (isChanged) {
      console.log("?? Preview changed:", preview);
      prevDropItems.current = preview;
    }
  }, [droppedItems]);

  useEffect(() => {
    console.log(droppedItems, "aaaa", dragItems);
  }, [droppedItems, dragItems]);
  useEffect(() => {
    console.log("?? Updated droppedItems:", droppedItems);
  }, [droppedItems]);

  // Both visibilityRules and linkedWorkflowRules are rewritten wholesale by the
  // save (there's no *IdsToBeDeleted list for either), so every field echoes back
  // the rules it loaded, minus anything the backend would reject.
  const buildFieldsMetadata = (items) => {
    const sanitized = mapFieldsSanitizeLinkedWorkflowRules(
      mapFieldsSanitizeVisibilityRules(items)
    );
    const { cleanedItems, markerFields } =
      buildLinkedWorkflowMarkerFields(sanitized);
    return [...(cleanedItems || []), ...(markerFields || [])];
  };

  const fieldsHaveVisibilityConditionForOption = (
    items,
    sourceUniqueKey,
    optionValue,
  ) =>
    flattenWorkflowFields(items).some(
      (field) =>
        Array.isArray(field?.visibilityRules) &&
        field.visibilityRules.some(
          (rule) =>
            Array.isArray(rule?.conditions) &&
            rule.conditions.some(
              (condition) =>
                condition?.sourceUniqueKey === sourceUniqueKey &&
                condition?.expectedValue === optionValue,
            ),
        ),
    );

  const fieldsHaveLinkedWorkflowForOption = (
    items,
    sourceUniqueKey,
    optionValue,
  ) =>
    flattenWorkflowFields(items).some((field) =>
      getLinkedWorkflowRules(field).some(
        (rule) =>
          Array.isArray(rule?.conditions) &&
          rule.conditions.some(
            (condition) =>
              condition?.sourceUniqueKey === sourceUniqueKey &&
              condition?.expectedValue === optionValue,
          ),
      ),
    );

  // A field option can be used in either a visibility rule or a workflow link,
  // but not both. This is enforced per option value so unrelated options still work.
  const validateFieldRelationshipExclusivity = (...itemLists) => {
    const allFields = itemLists.flatMap((items) => flattenWorkflowFields(items));
    for (const items of itemLists) {
      for (const field of flattenWorkflowFields(items)) {
        for (const rule of getLinkedWorkflowRules(field)) {
          for (const condition of rule.conditions || []) {
            if (
              fieldsHaveVisibilityConditionForOption(
                allFields,
                condition.sourceUniqueKey,
                condition.expectedValue,
              )
            ) {
              const fieldLabel = field.fieldName || field.uniqueKey || "This field";
              toast.error(
                translations[langMode].linkedWorkflowConditionSaveConflict
                  .replace("{field}", fieldLabel)
                  .replace("{option}", condition.expectedValue),
              );
              return false;
            }
          }
        }
      }
    }
    return true;
  };

  // The same checks /workflow/update answers 601 for, run before the request so
  // the message names the field instead of arriving as a bare server toast.
  const validateLinkedWorkflows = (...itemLists) => {
    const allowedWorkflowIds = linkedWorkflowsLoading
      ? null
      : linkedWorkflowOptions.map((option) => option.value);

    if (!validateFieldRelationshipExclusivity(...itemLists)) return false;

    for (const items of itemLists) {
      const error = validateLinkedWorkflowRules(items, {
        allowedWorkflowIds,
        currentWorkflowId: openWorkflowId,
      });
      if (error) {
        toast.error(error);
        return false;
      }
    }
    return true;
  };

  const workflowUpdate = async (isEdit = true) => {
    if (!validateSafetyChecklist()) return;
    if (!validateLinkedWorkflows(mainDroppedItems)) return;

    const dataToSend = {
      projectId: projectId,
      workflowId: workflowId,
      timer: isEdit ? selectedTimer : workflowTimer,
      pdfTitle: isEdit ? title : existPdfTitleName,
      workflowName: isEdit ? workflowName : existWorkflowName,
      maxAllowedAccuracy, // update by harshit
      fieldsMetadata: buildFieldsMetadata(mainDroppedItems),
      fieldIdsToBeDeleted: mainFieldIdsToBeDeleted,
      radioValueIdsToBeDeleted: mainRadioValueIdsToBeDeleted,
      validationValueToBeDeleted: mainValidationIdsToBeDeleted,
      taskExcelColumns: taskExcelColumns,
      accountProtectionCheck: accountProtection,
      clockin: selectedOption === "clockin",
      clockout: selectedOption === "clockout",
      isPageWise: isPageWise,
      // ------- sakshi -------- start
      isReviewEnabled: isReviewEnabled,
      // ------- sakshi -------- end
      isShowDistance: isShowDistance,
      isSafetyComplianceRequired: isSafetyComplianceRequired,
      isOptionShow: computeIsOptionShow(mainDroppedItems),
    };

    try {
      setLoading(true);

      // Only the main workflow -- the safety child has its own buttons.
      // Upload the stamp image to S3 first, then send its URL in the JSON
      const stampUrl = await resolveCompanyStampUrl();
      if (stampUrl) {
        dataToSend.companyStamp = stampUrl;
      }

      const jsonData = await updateWorkflow(dataToSend);

      if (jsonData && jsonData.header.code === 600) {
        toast.success(jsonData.body.value);
        navigate("/workflow");
        localStorage.removeItem("selectedFields");
        setLoading(false);
      } else if (jsonData.header.code === 601) {
        toast.error(jsonData.body.value);
        setLoading(false);
      } else if (jsonData) {
        toast.error(jsonData.body.value);
        setLoading(false);
      }
    } catch (err) {
      console.error("Error updating workflow:", err);
      setLoading(false);
    }
  };

  const handleVersionClick = async () => {
    try {
      if (workflowId) {
        setLoading(true); // Set loading to true when data fetching starts
        const jsonData = await fetchWorkflowHistory(
          workflowId,
          pages,
          size,
          langMode,
        ); // Pass page to the API
        if (jsonData && jsonData.header.code === 600) {
          const newHistories = jsonData.body.value.workflowHistories;
          if (newHistories.length > 0) {
            const existingIds = new Set(
              workflowVersionHistories.map((history) => history.id),
            );
            const uniqueNewHistories = newHistories.filter(
              (newHistory) => !existingIds.has(newHistory.id),
            );
            if (uniqueNewHistories.length > 0) {
              setWorkflowVersionHistories((prevHistories) => [
                ...prevHistories,
                ...uniqueNewHistories,
              ]);
            } else {
              toast.info(translations[langMode].nomoreuniqueversion);
            }
          } else {
            toast.info(translations[langMode].nomoreversionavailble);
            setHasMore(false); // No more data to fetch
          }
        } else {
          toast.info(translations[langMode].createworkflowdiagram);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); // Stop loading
    }
  };
  const triggerVersion = () => {
    if (!showVersions) {
      // If opening versions, fetch the workflow history
      handleVersionClick(); // Fetch versions
    } else {
      // If closing versions, reset the version histories to an empty state
      setWorkflowVersionHistories([]); // Clear version histories
      setPages(0);
    }

    // Toggle visibility
    setShowVersions((val) => !val);
  };
  useEffect(() => {
    // linkedWorkflowRules are documented on the fields get-workflow-metadata
    // returns; dragItems is the maker's own blob, so the rules are folded in from
    // there before the canvas is seeded. The update payload is built from this
    // tree and rewrites linked_workflow_json wholesale, so a rule that didn't
    // make it in here would be erased on the next save.
    const { markerFields, normalFields } =
      splitLinkedWorkflowMarkerFields(workflowFields ?? []);
    const filteredDragItems = stripLinkedWorkflowMarkerFields(
      existDragItems ?? []
    );
    const seededFields =
      filteredDragItems && filteredDragItems.length > 0
        ? hydrateLinkedWorkflowRules(filteredDragItems, normalFields)
        : filteredDragItems;
    const seededFromMarkers = applyLinkedWorkflowMarkers(
      seededFields,
      markerFields
    );

    if (existDragItems && existDragItems.length > 0) {
      setMainDroppedItems(seededFromMarkers);
      if (Array.isArray(normalFields) && normalFields.length > 0) {
        normalFields.forEach((field) => {
          if (Array.isArray(field.validationValues)) {
            setValidationFormValues(field.validationValues);
          } else {
            console.error(
              `validationValues is not an array for field: ${field.fieldName}`,
            );
          }
        });
      } else {
        console.error(
          "existDragItems is either not defined or not an array or is empty.",
        );
      }
    }
    if (existDragItems && existDragItems.length > 0) {
      setMainDragItems(seededFromMarkers);
      setMainMaxPage(
        Math.max(
          1,
          ...seededFromMarkers
            .map((item) => Number(item?.page) || 1)
            .filter((value) => Number.isFinite(value)),
        ),
      );
    }
    if (existRadioButtons && existRadioButtons.length > 0) {
      setMainRadioButtons(existRadioButtons);
    }
  }, [workflowFields]);

  const handleTimer = (event) => {
    setSelectedTimer(parseInt(event.target.value));
  };

  const handleChangee = (event) => {
    setworkflowName(event.target.value);
  };

  // update by harshit -- start
  const handleMaxAllowedAccuracyChangee = (event) => {
    setMaxAllowedAccuracy(event.target.value);
  };
  // update by harshit -- end

  const handleCheckAccountProtection = () => {
    setAccountProtectionCheck(!accountProtection);
  };

  // Clock in / Clock out share one mutually-exclusive selection (moved up from CloneOption.js, same logic).
  const handleOptionChange = (e) => {
    const value = e.target.value;
    if (selectedOption === value) {
      setSelectedOption(null);
    } else {
      setSelectedOption(value);
    }
  };

  // "Add Fields For Report" / "Select Mandatory Field" header buttons (moved up from CloneOption.js, same logic).
  const handleGetfields = async () => {
    try {
      const data = await getFieldNames(workflowId);
      if (data.header.code === 600) {
        if (data && data.body && Array.isArray(data.body.value)) {
          if (data.body.value.length === 0) {
            toast.warn(translations[langMode].nofieldabuplodtasksheet);
            return;
          } else {
            setFields(data.body.value);
          }
        }
        setOpen(true);
      }
      console.log(data);
    } catch (error) {
      console.error("Error fetching field names:", error);
    }
  };

  const handlefields = () => {
    if (manfields) {
      setManOpen(true);
    } else {
      toast.warn(translations[langMode].nofieldavailable);
    }
  };

  useEffect(() => {
    const fetchMandatoryFields = async () => {
      if (isEdit && workflowId) {
        try {
          const data = await getField(workflowId);
          if (data?.header?.code === 600) {
            if (data?.body?.value?.mandatoryColumns?.length > 0 || data?.body?.value?.otherColumns?.length > 0) {
              setManFields(data.body.value);
            } else {
              setManFields(false);
            }
          }
        } catch (error) {
          console.error("Error fetching mandatory fields:", error);
          setManFields(false);
        }
      }
    };

    fetchMandatoryFields();
  }, [isEdit, workflowId]);

  const handleIsPageWiseChange = () => {
    setIsPageWise((prev) => !prev);
  };

  // ------- sakshi -------- start
  const handleIsReviewEnabledChange = () => {
    setIsReviewEnabled((prev) => !prev);
  };
  // ------- sakshi -------- end

  const handleIsShowDistanceChange = () => {
    setIsShowDistance((prev) => !prev);
  };

  // Turning safety compliance off only ungates task completion -- the fields already
  // built stay in state (and on the server) so an accidental untick doesn't throw the
  // work away. Removing the safety row itself is a separate, explicit delete.
  const handleSafetyComplianceChange = () => {
    setIsSafetyComplianceRequired((prev) => {
      if (prev) setBuilderTarget("main");
      return !prev;
    });
  };

  const handleSafetyWorkflowNameChange = (event) => {
    setSafetyWorkflowName(event.target.value);
  };

  const handleBuilderTargetChange = (target) => {
    if (target === builderTarget) return;
    setBuilderTarget(target);
  };

  // Enough of a safety form to be worth sending: the API requires a name and a
  // non-empty field list.
  const hasSafetyForm =
    Boolean(safetyWorkflowName.trim()) && safetyDroppedItems.length > 0;

  // SafetyWorkflowRequest. `pdfTitle` and `timer` are optional (they default to the
  // name and the parent's timer) but sending them keeps the child explicit.
  const buildSafetyWorkflowRequest = () => ({
    workflowName: safetyWorkflowName.trim(),
    pdfTitle: safetyWorkflowName.trim(),
    timer: selectedTimer,
    fieldsMetadata: buildFieldsMetadata(safetyDroppedItems),
  });

  const validateSafetyForm = () => {
    if (!safetyWorkflowName.trim()) {
      toast.error(
        translations[langMode].enterSafetyChecklistName ??
          "Enter a name for the safety checklist",
      );
      return false;
    }
    if (safetyDroppedItems.length === 0) {
      toast.error(
        translations[langMode].safetyChecklistNeedsField ??
          "Add at least one field to the safety checklist",
      );
      return false;
    }
    if (!validateLinkedWorkflows(safetyDroppedItems)) return false;
    return true;
  };

  // Guard for saving the *main* workflow. On edit the safety child is saved by its
  // own button, so all the parent needs is for that row to already exist --
  // /workflow/update rejects the flag otherwise. On create/clone the child rides
  // along nested in the same request, so the form itself has to be complete.
  const validateSafetyChecklist = () => {
    if (!isSafetyComplianceRequired) return true;
    if (isEdit) {
      if (!safetyWorkflowId) {
        toast.error(
          translations[langMode].createSafetyChecklistFirst ??
            "Create the safety checklist first, then enable safety compliance",
        );
        setBuilderTarget("safety");
        return false;
      }
      return true;
    }
    if (!validateSafetyForm()) {
      setBuilderTarget("safety");
      return false;
    }
    return true;
  };

  const clearSafetyDeletionQueues = () => {
    setSafetyFieldIdsToBeDeleted([]);
    setSafetyRadioValueIdsToBeDeleted([]);
    setSafetyValidationIdsToBeDeleted([]);
  };

  // The safety child gets its own create / update / delete buttons rather than
  // riding along with the main workflow's save, so a click always names the row it
  // writes to.
  const handleCreateSafetyWorkflowClick = async () => {
    if (!validateSafetyForm()) return;
    setLoading(true);
    try {
      const newSafetyWorkflowId = await createSafetyWorkflow({
        mainWorkflowId: workflowId,
        ...buildSafetyWorkflowRequest(),
      });
      setSafetyWorkflowId(newSafetyWorkflowId);
      clearSafetyDeletionQueues();
      toast.success(
        translations[langMode].safetyChecklistCreated ??
          "Safety checklist created",
      );
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateSafetyWorkflowClick = async () => {
    if (!validateSafetyForm()) return;
    setLoading(true);
    try {
      const message = await updateSafetyWorkflow({
        workflowId: safetyWorkflowId,
        ...buildSafetyWorkflowRequest(),
        fieldIdsToBeDeleted: safetyFieldIdsToBeDeleted,
        radioValueIdsToBeDeleted: safetyRadioValueIdsToBeDeleted,
        validationValueToBeDeleted: safetyValidationIdsToBeDeleted,
      });
      clearSafetyDeletionQueues();
      toast.success(message);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Keyed by the *main* workflow id. The backend refuses while safety compliance is
  // still enabled on the parent, so its message is surfaced as-is.
  const handleDeleteSafetyWorkflowClick = async () => {
    setLoading(true);
    try {
      const message = await deleteSafetyWorkflow(workflowId);
      setSafetyWorkflowId(null);
      setSafetyWorkflowName("");
      setSafetyDroppedItems([]);
      setSafetyDragItems([]);
      setSafetyRadioButtons([]);
      setSafetyPreview({ fieldType: "" });
      setSafetyPage(1);
      setSafetyMaxPage(1);
      clearSafetyDeletionQueues();
      setBuilderTarget("main");
      toast.success(message);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
      setShowDeleteSafetyConfirm(false);
    }
  };

  // Company stamp upload: JPG/PNG/SVG only -- WEBP is deliberately excluded
  // because the stamp is re-rendered into the generated field-agent PDFs, which
  // don't handle it.
  const COMPANY_STAMP_ACCEPTED_TYPES = [
    "image/png",
    "image/jpeg",
    "image/jpg",
    "image/svg+xml",
  ];

  const handleCompanyStampChange = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    // Extension check is an OR fallback for files the browser reports with an
    // empty/odd MIME type, so it must exclude .webp too -- otherwise a WEBP
    // sneaks through whenever `file.type` isn't set.
    const isAccepted =
      COMPANY_STAMP_ACCEPTED_TYPES.includes(file.type) ||
      /\.(png|jpe?g|svg)$/i.test(file.name);
    if (!isAccepted) {
      toast.error(
        translations[langMode].companyStampInvalidType ??
          "Please upload a JPG, PNG or SVG image.",
      );
      event.target.value = "";
      return;
    }
    setCompanyStampPreview((prev) => {
      if (prev) URL.revokeObjectURL(prev);
      return URL.createObjectURL(file);
    });
    setCompanyStamp(file);
    event.target.value = "";
  };

  const handleRemoveCompanyStamp = () => {
    setCompanyStampPreview((prev) => {
      if (prev) URL.revokeObjectURL(prev);
      return "";
    });
    setCompanyStamp(null);
    const input = document.getElementById("companyStamp");
    if (input) input.value = "";
  };

  // Resolve the stamp URL to send with the workflow: upload a freshly picked
  // file to S3, otherwise reuse an already-hosted URL (edit mode). A local
  const resolveCompanyStampUrl = async () => {
    if (companyStamp) {
      const uploadedUrl = await uploadFileToS3(companyStamp);
      if (!uploadedUrl) {
        throw new Error("Company stamp upload failed");
      }
      return uploadedUrl;
    }
    if (companyStampPreview && !companyStampPreview.startsWith("blob:")) {
      return companyStampPreview;
    }
    return "";
  };

  // Revoke the object URL when the component unmounts to avoid memory leaks.
  useEffect(() => {
    return () => {
      if (companyStampPreview) URL.revokeObjectURL(companyStampPreview);
    };
  }, [companyStampPreview]);

  const titleHandle = (event) => {
    setTitle(event.target.value);
  };

  const handleReportInput = (event) => {
    setreportInput(event.target.value);
    setReportIcon(false); // Reset the green icon on typing
  };

  const handlePdfInput = (event) => {
    setPdfInput(event.target.value);
    setPdfIcon(false); // Reset the green icon on typing
  };

  const workflowSubmit = async () => {
    if (!validateSafetyChecklist()) return;
    if (!validateLinkedWorkflows(mainDroppedItems)) return;

    const status =
      selectedOption === null
        ? { clockin: null, clockout: null }
        : selectedOption === "clockin"
          ? { clockin: true, clockout: false }
          : selectedOption === "clockout"
            ? { clockin: false, clockout: true }
            : { clockin: null, clockout: null };

    const dataToSend = {
      timer: selectedTimer,
      workflowName: workflowName,
      maxAllowedAccuracy, // update by harshit
      pdfTitle: title,
      fieldsMetadata: buildFieldsMetadata(mainDroppedItems),
      projectId: projectId,
      accountProtectionCheck: accountProtection,
      isPageWise: isPageWise,
      // ------- sakshi -------- start
      isReviewEnabled: isReviewEnabled,
      // ------- sakshi -------- end
      isShowDistance: isShowDistance,
      isSafetyComplianceRequired: isSafetyComplianceRequired,
      isOptionShow: computeIsOptionShow(mainDroppedItems),
      ...status,
    };
    // create-workflow persists the parent and its safety child in one transaction.
    if (hasSafetyForm) {
      dataToSend.safetyWorkflow = buildSafetyWorkflowRequest();
    }

    try {
      setLoading(true);

      // Upload the stamp image to S3 first, then send its URL in the JSON
      const stampUrl = await resolveCompanyStampUrl();
      if (stampUrl) {
        dataToSend.companyStamp = stampUrl;
      }

      const jsonData = await createWorkflow(dataToSend);
      if (jsonData && jsonData.header.code === 600) {
        toast.success(jsonData.body.value);
        navigate("/workflow");
        setLoading(false);
      } else if (jsonData) {
        toast.error(jsonData.body.value);
        setLoading(false);
      }
    } catch (err) {
      console.error("Error submitting workflow:", err);
      setLoading(false);
    }
  };

  function updateNestedAllInputValues(items, targetUniqueKey, newInputData) {
    return items.map((item) => {
      if (item.uniqueKey === targetUniqueKey) {
        return {
          ...item,
          allInputValues: [...newInputData],
        };
      }
      if (item.radioInputValues && item.radioInputValues.length > 0) {
        const updatedRadioInputValues = updateNestedAllInputValues(
          item.radioInputValues,
          targetUniqueKey,
          newInputData,
        );
        return { ...item, radioInputValues: updatedRadioInputValues };
      }
      return item;
    });
  }

  const updateAllInputValues = (
    updatedValues,
    previewkey,
    oldValue,
    newValue,
  ) => {
    let newAllInputValues = [];
    updatedValues.forEach((input) => {
      if (input.uniqueKey === previewkey && input.value !== "") {
        const key = input.radioKey !== undefined ? input.radioKey : input.id;
        const newEntry = {
          inputKey: `input-${key}`,
          inputValue: input.value,
        };
        if (input.workflowFormFieldMetadataId !== undefined) {
          newEntry.id = input.id;
        }
        newAllInputValues.push(newEntry);
      }
    });

    const applyUpdates = (items) => {
      const withInputValues = updateNestedAllInputValues(
        items,
        previewkey,
        newAllInputValues,
      );
      // Both rule kinds match on the option's visible label, so a rename has to
      // be followed through or the rule silently stops matching.
      return renameLinkedWorkflowExpectedValue(
        renameVisibilityRuleExpectedValue(
          withInputValues,
          previewkey,
          oldValue,
          newValue,
        ),
        previewkey,
        oldValue,
        newValue,
      );
    };

    const updatedDroppedItems = applyUpdates(droppedItems);
    setDroppedItems(updatedDroppedItems);
    setDragItems((prevItems) => applyUpdates(prevItems));
    setPreview((prev) =>
      prev?.uniqueKey === previewkey
        ? { ...prev, allInputValues: newAllInputValues }
        : prev,
    );
  };

  const handleAddInput = (uniqueKey, page) => {
    const nextKey = `${new Date().getTime()}`;
    setInputValues([
      ...inputValues,
      { id: nextKey, value: "", uniqueKey: uniqueKey },
    ]);

    setRadioButtons([
      ...radioButtons,
      {
        id: nextKey,
        value: "",
        uniqueKey: uniqueKey,
        isShow: true,
        radioPage: page,
      },
    ]);
  };

  const addReportfield = (previewKey, reportName) => {
    if (!reportInput && !reportName) {
      toast.warn(translations[langMode].updatepdfnamefirst);
      return;
    }
    const updatedData = droppedItems.map((item) => {
      if (item.uniqueKey === previewKey) {
        return {
          ...item,
          reportName: reportInput,
          reportField: false,
          isReport: true,
        };
      }
      return item;
    });
    setDroppedItems(updatedData);
    setDragItems(updatedData);
    setReportIcon(true);
    toast.success(translations[langMode].pdfnameupdate);
    console.log(updatedData);
  };

  const addPdffield = (previewKey, excelReportName) => {
    if (!pdfInput && !excelReportName) {
      toast.warn(translations[langMode].updatereportname);
      return;
    }
    const updatedData = droppedItems.map((item) => {
      if (item.uniqueKey === previewKey) {
        return {
          ...item,
          excelReportName: pdfInput,
          showInput: false,
        };
      }
      return item;
    });
    setDroppedItems(updatedData);
    setDragItems(updatedData);
    setPdfIcon(true);
    toast.success(translations[langMode].excelnameupdate);
    console.log(updatedData);
  };

  const onCloseValidation = () => setValidationModal(false);
  const [validationFormValues, setValidationFormValues] = useState([]);
  const [currentValidation, setCurrentValidation] = useState({
    validationId: validationId,
    validationCode: "",
    errorMessage: "",
    uniqueKey: "",
  });

  const handleCreateValidation = (event) => {
    event.preventDefault();

    if (!currentValidation.validationCode) return;

    const validationWithId = {
      ...currentValidation,
      validationId: currentValidation.validationId || Date.now(),
    };

    // Append; if editing same id ? update
    const updatedList = [...validationFormValues];
    const index = updatedList.findIndex(
      (v) => v.validationId === validationWithId.validationId,
    );

    if (index > -1) {
      updatedList[index] = validationWithId;
    } else {
      updatedList.push(validationWithId);
    }

    setValidationFormValues(updatedList);
    updateValidationField(updatedList, currentValidation.uniqueKey);

    // Reset only input fields, keep validation list unchanged
    setCurrentValidation({
      validationId: Date.now(),
      validationCode: "",
      errorMessage: "",
      uniqueKey: currentValidation.uniqueKey,
    });

    setValidationModal(false);
  };

  const updateValidationField = (validations, previewKey) => {
    let newValidationVals = validations
      .filter(
        (input) =>
          input.uniqueKey === previewKey && input.validationCode !== "",
      )
      .reduce((unique, current) => {
        const exists = unique.find(
          (item) => item.validationId === current.validationId,
        );
        return exists ? unique : [...unique, current];
      }, []);

    const updatedDroppedItems = updateNestedFiledValidations(
      droppedItems,
      previewKey,
      newValidationVals,
    );
    setDroppedItems(updatedDroppedItems);
  };

  function updateNestedFiledValidations(items, targetUniqueKey, newInputData) {
    return items.map((item) => {
      if (item.uniqueKey === targetUniqueKey) {
        return {
          ...item,
          validationValues: Array.from(
            new Map(newInputData.map((v) => [v.validationId, v])).values(),
          ),
        };
      } else if (item.radioInputValues && item.radioInputValues.length > 0) {
        const updatedRadioInputValues = updateNestedFiledValidations(
          item.radioInputValues,
          targetUniqueKey,
          newInputData,
        );
        return {
          ...item,
          radioInputValues: updatedRadioInputValues,
        };
      }
      return item;
    });
  }

  const handleValidationDelete = (id, previewKey, editId) => {
    setValidationFormValues((prevItems) =>
      prevItems.filter((item) => item.validationId !== id),
    );

    setDroppedItems((prevItems) =>
      prevItems.map((item) => ({
        ...item,
        validationValues: item.validationValues?.filter(
          (v) => v.validationId !== id,
        ),
      })),
    );

    setValidationsDeleteId((prev) => [...prev, editId]);
  };

  function deleteValidationFromItem(item, id, previewKey) {
    if (item.uniqueKey === previewKey) {
      if (item.validationValues) {
        item.validationValues = item.validationValues.filter(
          (validation) => validation.validationId !== `validation-${id}`,
        );
      }
      if (item.radioInputValues && item.radioInputValues.length > 0) {
        item.radioInputValues = item.radioInputValues.map((nestedItem) =>
          deleteValidationFromItem(nestedItem, id, previewKey),
        );
      }
    } else if (item.radioInputValues && item.radioInputValues.length > 0) {
      item.radioInputValues = item.radioInputValues.map((nestedItem) =>
        deleteValidationFromItem(nestedItem, id, previewKey),
      );
    }
    return item;
  }

  // Compare validation lives on the field itself as
  // `compareValidations: [{ secondaryUniqueKey, condition, errorMessage }]`,
  // which is the exact shape create/update/clone send, so it needs no mapping
  // on the way into `fieldsMetadata`. `editingSecondaryKey` is set when the
  // admin re-pointed an existing rule at a different second field.
  const applyCompareValidations = (previewKey, updater) => {
    const applyToTree = (tree) =>
      updateNestedItemByUniqueKey(tree, previewKey, (item) => {
        const nextRules = updater(
          Array.isArray(item.compareValidations) ? item.compareValidations : [],
        );
        return nextRules.length
          ? { ...item, compareValidations: nextRules }
          : { ...item, compareValidations: undefined };
      });

    setDroppedItems((prev) => {
      const next = applyToTree(prev);
      const updatedPreview = findItemRecursive(next, previewKey);
      if (updatedPreview) {
        queueMicrotask(() => setPreview(updatedPreview));
      }
      return next;
    });
    setDragItems((prev) => applyToTree(prev));
  };

  const handleSaveCompareValidation = (
    previewKey,
    rule,
    editingSecondaryKey = null,
  ) =>
    applyCompareValidations(previewKey, (rules) =>
      upsertCompareValidation(
        editingSecondaryKey && editingSecondaryKey !== rule.secondaryUniqueKey
          ? rules.filter(
              (item) => item.secondaryUniqueKey !== editingSecondaryKey,
            )
          : rules,
        rule,
      ),
    );

  const handleCompareValidationDelete = (previewKey, secondaryUniqueKey) =>
    applyCompareValidations(previewKey, (rules) =>
      rules.filter((rule) => rule.secondaryUniqueKey !== secondaryUniqueKey),
    );

  const handleRadioOptions = (id, value, previewkey) => {
    let updatedRadioValues = [...radioButtons];
    const index = updatedRadioValues.findIndex(
      (input) => input.id === id && input.uniqueKey === previewkey,
    );
    const previousValue =
      index !== -1 ? updatedRadioValues[index]?.value : undefined;
    if (index !== -1) {
      updatedRadioValues[index] = { ...updatedRadioValues[index], value };
    } else {
      updatedRadioValues.push({ id, value, uniqueKey: previewkey });
    }
    setRadioButtons(updatedRadioValues);
    updateAllInputValues(updatedRadioValues, previewkey, previousValue, value);
    setInputValues([{ id, value, uniqueKey: previewkey }]);
    removeSpecificInput(id, previewkey);
    toast.info(translations[langMode].inputvlueadded);
  };

  const removeSpecificInput = (idToRemove, uniqueKeyToRemove) => {
    const updatedRadioButtons = inputValues.filter(
      (input) =>
        !(input.id === idToRemove && input.uniqueKey === uniqueKeyToRemove),
    );
    setInputValues(updatedRadioButtons);
  };

  const handleRadioDeleteOptions = (id, radioKey, value, previewKey) => {
    const optionInputKey =
      radioKey !== undefined && radioKey !== null && radioKey !== ""
        ? `input-${radioKey}`
        : `input-${id}`;
    const parentItem = findItemRecursive(droppedItems, previewKey);
    const canDelete =
      !parentItem?.radioInputValues ||
      (Array.isArray(parentItem.radioInputValues) &&
        parentItem.radioInputValues.length === 0);

    if (!canDelete) {
      toast.warning(translations[langMode].warningthis);
      return;
    }

    const removeOptionFromItems = (items) =>
      items.map((item) => {
        const next =
          item.uniqueKey === previewKey
            ? {
                ...item,
                allInputValues: (item.allInputValues || []).filter(
                  (input) => input.inputKey !== optionInputKey,
                ),
              }
            : item;

        if (next.radioInputValues?.length) {
          return {
            ...next,
            radioInputValues: removeOptionFromItems(next.radioInputValues),
          };
        }
        return next;
      });

    const removeOptionAndRules = (items) =>
      removeLinkedWorkflowRulesForOption(
        removeVisibilityRuleCondition(
          removeOptionFromItems(items),
          previewKey,
          value,
        ),
        previewKey,
        value,
      );

    setradioValueIdsToBeDeleted((prevFieldIds) => [...prevFieldIds, id]);
    setDroppedItems((prevItems) => removeOptionAndRules(prevItems));
    setDragItems((prevItems) => removeOptionAndRules(prevItems));
    setRadioButtons((prevRadioButtons) => {
      const updatedRadioButtons = prevRadioButtons.filter(
        (btn) =>
          !(
            btn.id === id &&
            btn.radioKey === radioKey &&
            btn.uniqueKey === previewKey
          ),
      );
      return updatedRadioButtons;
    });
    setTempInputValue((prevValues) => {
      const keyToDelete = `${previewKey}-${id}`;
      const { [keyToDelete]: _, ...remainingValues } = prevValues;
      return remainingValues;
    });
    removeSpecificInput(id, previewKey);
  };

  const updateItems = (previewKey, updatedProps) => {
    const updateItemList = (items) =>
      items.map((item) => {
        if (item.uniqueKey === previewKey) {
          return { ...item, ...updatedProps };
        }
        if (item.radioInputValues) {
          return {
            ...item,
            radioInputValues: updateItemList(item.radioInputValues),
          };
        }
        return item;
      });

    setDroppedItems(updateItemList(droppedItems));
    setDragItems(updateItemList(dragItems));
  };

  const handleOptionShowToggle = (event, previewKey) => {
    updateItems(previewKey, { isOptionShow: event.target.checked });
    // keep preview in sync for controlled checkbox UI
    setPreview((prev) =>
      prev?.uniqueKey === previewKey
        ? { ...prev, isOptionShow: event.target.checked }
        : prev,
    );
  };

  // "Allow Gallery" toggle for image fields (Take Photo / Multiple Images).
  // Controls whether field agents may pick from the gallery or must use the camera.
  const handleAllowGalleryToggle = (event, previewKey) => {
    updateItems(previewKey, { allowGallery: event.target.checked });
    // keep preview in sync for controlled checkbox UI
    setPreview((prev) =>
      prev?.uniqueKey === previewKey
        ? { ...prev, allowGallery: event.target.checked }
        : prev,
    );
  };

  // A fixed "W:H" ratio locks width/height together. "Custom" (or no selection)
  // leaves the two dimensions independent.
  const isLockedAspectRatio = (ratio) =>
    typeof ratio === "string" &&
    ratio.toLowerCase() !== "custom" &&
    /^\d+:\d+$/.test(ratio);

  const handlePhotoConstraintChange = (previewKey, key, rawValue) => {
    const current =
      findItemRecursive(droppedItems, previewKey)?.photoConstraints || {};

    let value;
    if (key === "aspectRatio") {
      value = rawValue ? rawValue : undefined;
    } else {
      const parsed = parseInt(rawValue, 10);
      value =
        rawValue === "" || Number.isNaN(parsed) || parsed <= 0
          ? undefined
          : parsed;
    }

    const merged = { ...current, [key]: value };

    // When a fixed aspect ratio is active, keep width and height in sync with it:
    // editing one dimension derives the other, and selecting a ratio re-derives
    // from whichever dimension already has a value (width takes precedence).
    if (isLockedAspectRatio(merged.aspectRatio)) {
      const [rw, rh] = merged.aspectRatio.split(":").map(Number);
      if (rw > 0 && rh > 0) {
        if (key === "widthPx" && merged.widthPx) {
          merged.heightPx = Math.round((merged.widthPx * rh) / rw);
        } else if (key === "heightPx" && merged.heightPx) {
          merged.widthPx = Math.round((merged.heightPx * rw) / rh);
        } else if (key === "aspectRatio") {
          if (merged.widthPx) {
            merged.heightPx = Math.round((merged.widthPx * rh) / rw);
          } else if (merged.heightPx) {
            merged.widthPx = Math.round((merged.heightPx * rw) / rh);
          }
        }
      }
    }

    const cleaned = Object.fromEntries(
      Object.entries(merged).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const photoConstraints =
      Object.keys(cleaned).length > 0 ? cleaned : undefined;

    updateItems(previewKey, { photoConstraints });
    setPreview((prev) =>
      prev?.uniqueKey === previewKey ? { ...prev, photoConstraints } : prev,
    );
  };

  const handleInputChange = (event, previewKey) => {
    const updatedProps = { fieldName: event.target.value };
    updateItems(previewKey, updatedProps);
  };
  const reportMandatory = (event, previewKey) => {
    const updatedProps = {
      isReport: isChecked,
      ...(isChecked ? {} : { reportName: "" }), // Clear reportName when unchecked
    };
    console.log(updatedProps);
    console.log("Before Update:", droppedItems); // Debug before
    updateItems(previewKey, updatedProps);

    setreportField(event.target.checked);
    console.log("after Update:", droppedItems); // Debug before
  };

  const pdfMandatory = (event, previewKey) => {
    const updatedProps = { isPdf: event.target.checked };
    updateItems(previewKey, updatedProps);
    setShowInput(event.target.checked);
  };

  const handleToggleChange = (event, preview) => {
    setIsChecked(false);
    const newDroppedItems = [...droppedItems];
    const newDraggedItems = [...dragItems];
    const newItem = newDraggedItems.find((item) => item.uniqueKey === preview);
    if (newItem) {
      let droppedItem = newDroppedItems.find(
        (item) => item.uniqueKey === preview,
      );
      if (!droppedItem) {
        newDroppedItems.forEach((item) => {
          if (item.radioInputValues) {
            item.radioInputValues.forEach((radioInput) => {
              if (radioInput.uniqueKey === preview) {
                droppedItem = radioInput;
              }
            });
          }
        });
      }
      if (droppedItem) {
        droppedItem.isMandatory = event.target.checked;
        if (droppedItem.radioInputValues) {
          droppedItem.radioInputValues.forEach((radioInput) => {
            radioInput.isMandatory = event.target.checked;
          });
        }
      } else {
        console.error("Item not found in droppedItems");
      }
    } else {
      console.error("Item not found in draggedItems");
    }
    const newDroppedItem = dragItems.find((item) => item.uniqueKey === preview);
    newDroppedItem.isMandatory = event.target.checked;
    setDroppedItems(newDroppedItems);
    setDragItems(newDraggedItems);
    setPreview(newItem);
  };

  function getFieldNameByInputKey(keyNumber, previewKey) {
    const inputKey = `input-${keyNumber}`;
    let foundFieldName = null;
    for (const item of droppedItems) {
      if (item.allInputValues) {
        for (const input of item.allInputValues) {
          if (input.inputKey === inputKey) {
            foundFieldName = item.fieldName;
            let updatedRadioValues = [...radioButtons];
            const index = updatedRadioValues.findIndex(
              (radioInput) =>
                radioInput.id === keyNumber &&
                radioInput.uniqueKey === previewKey,
            );
            if (index !== -1) {
              updatedRadioValues[index] = {
                ...updatedRadioValues[index],
                fieldName: foundFieldName,
              };
            } else {
              updatedRadioValues.push({
                id: keyNumber,
                fieldName: foundFieldName,
                uniqueKey: previewKey,
              });
            }
            setRadioButtons(updatedRadioValues);
            break;
          }
        }
      }
      if (foundFieldName) break;
    }
    return foundFieldName;
  }

  const handleRadioBtnBelongs = (
    radioUniqueKey,
    radioId,
    value,
    preview,
    radioKey,
    ruleIndex = 0,
    checked = true,
  ) => {
    if (!checked) {
      getFieldNameByInputKey(radioId, radioUniqueKey);
      const applyToggle = (tree) =>
        updateNestedItemByUniqueKey(tree, preview.uniqueKey, (item) => {
          const base = visibilityRulesWithLegacySeed(tree, item);
          const newRules = toggleVisibilityCondition(
            base,
            ruleIndex,
            radioUniqueKey,
            value,
            checked,
          );
          return {
            ...item,
            radioId: null,
            ...(newRules.length
              ? { visibilityRules: newRules }
              : { visibilityRules: undefined }),
          };
        });

      setDroppedItems((prev) => {
        const next = applyToggle(prev);
        const updatedPreview = findItemRecursive(next, preview.uniqueKey);
        if (updatedPreview) {
          queueMicrotask(() => setPreview(updatedPreview));
        }
        return next;
      });
      setDragItems((prev) => applyToggle(prev));
      return;
    }

    if (
      fieldsHaveLinkedWorkflowForOption(
        droppedItems,
        radioUniqueKey,
        value,
      ) ||
      fieldsHaveLinkedWorkflowForOption(dragItems, radioUniqueKey, value)
    ) {
      toast.warn(
        translations[langMode].linkedWorkflowConditionConflict.replace(
          "{option}",
          value,
        ),
      );
      return;
    }

    getFieldNameByInputKey(radioId, radioUniqueKey);

    const applyToggle = (tree) =>
      updateNestedItemByUniqueKey(tree, preview.uniqueKey, (item) => {
        const base = visibilityRulesWithLegacySeed(tree, item);
        const newRules = toggleVisibilityCondition(
          base,
          ruleIndex,
          radioUniqueKey,
          value,
          checked,
        );
        return {
          ...item,
          radioId: null,
          ...(newRules.length
            ? { visibilityRules: newRules }
            : { visibilityRules: undefined }),
        };
      });

    setDroppedItems((prev) => {
      const next = applyToggle(prev);
      const updatedPreview = findItemRecursive(next, preview.uniqueKey);
      if (updatedPreview) {
        queueMicrotask(() => setPreview(updatedPreview));
      }
      return next;
    });
    setDragItems((prev) => applyToggle(prev));
  };

  // One rule per (option, workflow) pair, each with a single condition that
  // self-references the field on the option's visible label -- task_data_json
  // stores the label, so that's what the reports match on. Passing a null
  // workflowId clears the option's link.
  const handleLinkedWorkflowChange = (
    fieldUniqueKey,
    optionValue,
    linkedWorkflowId,
  ) => {
    if (linkedWorkflowId != null && linkedWorkflowId !== "") {
      if (
        fieldsHaveVisibilityConditionForOption(
          droppedItems,
          fieldUniqueKey,
          optionValue,
        ) ||
        fieldsHaveVisibilityConditionForOption(
          dragItems,
          fieldUniqueKey,
          optionValue,
        )
      ) {
        toast.warn(
          translations[langMode].conditionLinkedWorkflowConflict.replace(
            "{option}",
            optionValue,
          ),
        );
        return;
      }
    }

    const applyLink = (tree) =>
      updateNestedItemByUniqueKey(tree, fieldUniqueKey, (item) => {
        const rules = setLinkedWorkflowForOption(
          item,
          optionValue,
          linkedWorkflowId,
        );
        return {
          ...item,
          ...(rules.length
            ? { linkedWorkflowRules: rules }
            : { linkedWorkflowRules: undefined }),
        };
      });

    setDroppedItems((prev) => {
      const next = applyLink(prev);
      const updatedPreview = findItemRecursive(next, fieldUniqueKey);
      if (updatedPreview) {
        queueMicrotask(() => setPreview(updatedPreview));
      }
      return next;
    });
    setDragItems((prev) => applyLink(prev));
  };

  const handleRemoveInput = () => {
    setInputValues(inputValues.slice(0, -1));
  };
  const shouldRenderSelectOption = radioButtons.some(
    (input) => input.uniqueKey !== preview.uniqueKey && input.value !== "",
  );
  const shouldRenderSelectOptionEdit = radioButtons.some(
    (input) => input.uniqueKey === preview.uniqueKey && input.value !== "",
  );
  const handleRemoveElement = (uniqueKey, backendkey) => {
    const collectNestedKeys = (item) => {
      let keys = [];
      if (item.radioInputValues) {
        for (const nestedItem of item.radioInputValues) {
          keys.push(nestedItem.uniqueKey);
          keys = keys.concat(collectNestedKeys(nestedItem));
        }
      }
      return keys;
    };

    const removeItemRecursive = (items, uniqueKey, collectedKeys = []) => {
      return items.reduce((acc, item) => {
        if (item.uniqueKey === uniqueKey) {
          collectedKeys.push(...collectNestedKeys(item));
          return acc;
        }
        if (item.radioInputValues) {
          item.radioInputValues = removeItemRecursive(
            item.radioInputValues,
            uniqueKey,
            collectedKeys,
          );
        }
        acc.push(item);
        return acc;
      }, []);
    };

    // Remove from droppedItems and update its state
    let collectedKeys = [];
    let updatedDroppedItems = removeItemRecursive(
      droppedItems,
      uniqueKey,
      collectedKeys,
    );

    updatedDroppedItems = updatedDroppedItems.map((item, index) => ({
      ...item,
      queNo: index + 1,
    }));

    // Fields left behind must not keep comparing against one that's now gone.
    const removedKeys = [uniqueKey, ...collectedKeys];
    setDroppedItems(
      removeCompareValidationsTargeting(updatedDroppedItems, removedKeys),
    );

    // Apply the same logic to dragItems
    let updatedDragItems = removeItemRecursive(
      dragItems,
      uniqueKey,
      collectedKeys,
    );

    updatedDragItems = updatedDragItems.map((item, index) => ({
      ...item,
      queNo: index + 1,
    }));

    setDragItems(
      removeCompareValidationsTargeting(updatedDragItems, removedKeys),
    );

    // Filter radioButtons that are not part of the collected keys
    const updatedRadioButtons = radioButtons.filter(
      (item) =>
        !collectedKeys.includes(item.uniqueKey) &&
        !uniqueKey.includes(item.uniqueKey),
    );

    setRadioButtons(updatedRadioButtons);

    // Add the backendkey to fieldIdsToBeDeleted for later use
    setfieldIdsToBeDeleted((prevFieldIds) => [...prevFieldIds, backendkey]);

    // Update preview if the removed item was currently being previewed
    const updatedPreview = updatedDroppedItems.find(
      (item) => item.uniqueKey === uniqueKey,
    );
    setPreview(updatedPreview || {});

    toast.warn(translations[langMode].fieldremoved);
  };

  const selectedId = selectedRadioOption
    ? selectedRadioOption.split("-")[1]
    : "";

  const selectedRadioButton = radioButtons.find((button) => {
    const keyToCompare = button.radioKey ? button.radioKey : button.id;
    return String(keyToCompare) === String(selectedId);
  });

  const displaySelectedValue = selectedRadioButton
    ? selectedRadioButton.value
    : "";

  const question = selectedRadioButton ? selectedRadioButton.fieldName : "N/A";
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [workflowPreviewData, setWorkflowPreviewData] = useState([]);
  const handlePreviewClick = () => {
    setIsModalOpen(true);
    setWorkflowPreviewData(droppedItems);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  const navigate = useNavigate();
  const navigateToWorkflow = () => {
    navigate("/workflow");
  };

  const handleCloneElement = (cloneName, fieldName) => {
    const elementToClone = elements.find(
      (element) => element.cloneName === cloneName,
    );
    const elementWithInputValues = dragItems.find(
      (element) =>
        element.uniqueKey === preview.uniqueKey && element.allInputValues,
    );
    if (elementToClone) {
      const newUniqueKey = `${new Date().getTime()}`;
      const { icon, ...elementWithoutIcon } = elementToClone;
      const newElement = {
        ...elementWithoutIcon,
        uniqueKey: newUniqueKey,
        page,
        fieldName: fieldName,
      };
      if (elementWithInputValues) {
        let localNextId = nextId;
        const updatedInputValues = elementWithInputValues.allInputValues.map(
          (inputValue) => {
            const newInputKey = `input-${localNextId}`;
            const newRadioButton = {
              id: localNextId,
              value: inputValue.inputValue,
              uniqueKey: newUniqueKey,
              isShow: true,
              radioPage: page,
            };
            setRadioButtons((prevButtons) => [...prevButtons, newRadioButton]);
            const updatedInputValue = {
              ...inputValue,
              inputKey: newInputKey,
            };
            localNextId += 1;
            return updatedInputValue;
          },
        );
        newElement.allInputValues = updatedInputValues;
        setNextId(localNextId);
      }
      setDroppedItems((prevItems) => [...prevItems, newElement]);
      setDragItems((prevItems) => [...prevItems, newElement]);
      toast.warn(translations[langMode].fieldcloned);
    }
  };

  const groupedRadioButtons = radioButtons.reduce((acc, input) => {
    if (input.isShow === true && input.value !== "") {
      if (!acc[input.uniqueKey]) {
        acc[input.uniqueKey] = [];
      }
      acc[input.uniqueKey].push(input);
    }
    return acc;
  }, {});

  useEffect(() => {
    const initialCollapseState = Object.keys(groupedRadioButtons).reduce(
      (acc, uniqueKey) => {
        acc[uniqueKey] = true; // Start all groups collapsed
        return acc;
      },
      {},
    );

    // Update state only if it has actually changed
    setCollapsedGroups((prevState) => {
      // Check if the new state is different from the previous state
      const isDifferent = Object.keys(initialCollapseState).some(
        (key) => initialCollapseState[key] !== prevState[key],
      );

      return isDifferent ? initialCollapseState : prevState;
    });
  }, [JSON.stringify(groupedRadioButtons)]); // Serialize the object for comparison

  const toggleCollapse = (uniqueKey) => {
    setCollapsedGroups((prevState) => {
      console.log("Previous State:", prevState); // Debug previous state
      const newState = { ...prevState };
      Object.keys(newState).forEach((key) => {
        newState[key] = key === uniqueKey ? !newState[key] : true;
      });
      console.log("Updated State:", newState); // Debug updated state
      return newState;
    });
  };

  const getHeadline = (uniqueKey) => {
    const item = dragItems.find((item) => item.uniqueKey === uniqueKey);
    return item ? item.fieldName : "";
  };

  const removeIds = (items) => {
    return items.map((item) => {
      const { id, workflowId, ...rest } = item;
      const allInputValues = rest.allInputValues?.map((input) => {
        const { id, workflowFormFieldMetadataId, ...inputRest } = input;
        return inputRest;
      });

      return { ...rest, allInputValues };
    });
  };

  const workflowClone = async (isClone = true) => {
    setLoading(true);
    try {
      // The clone keeps its source's linked workflows -- they're workflows of the
      // same project, and the row being written is a new one, so none of them can
      // be a self-link.
      const removalIds = removeIds(
        mapFieldsSanitizeLinkedWorkflowRules(mainDroppedItems),
      );
      // The clone's safety child is created fresh alongside it, so strip source ids.
      const safetyWorkflowRequest = hasSafetyForm
        ? {
            ...buildSafetyWorkflowRequest(),
            fieldsMetadata: removeIds(buildFieldsMetadata(safetyDroppedItems)),
          }
        : null;
      const message = await cloneWorkflow(
        workflowName,
        maxAllowedAccuracy, // update by harshit
        selectedTimer,
        removalIds,
        selectedOrgId,
        title,
        projectId,
        isPageWise,
        isReviewEnabled,
        isShowDistance,
        isSafetyComplianceRequired,
        safetyWorkflowRequest,
      );
      if (message.header.code === 600) {
        toast.success(translations[langMode].clonedsuc);
        navigate("/workflow");
        setLoading(false);
      } else {
        toast.error(message.body.value);
        setLoading(false);
      }
    } catch (err) {
      toast.error(err.message);
      setLoading(false);
    }
  };

  const handleCloneClick = () => {
    if (!workflowName.trim()) {
      toast.error(translations[langMode].pleaseentername);
      return;
    }
    if (!validateSafetyChecklist()) return;
    if (!validateLinkedWorkflows(mainDroppedItems)) return;
    workflowClone(true);
  };

  const handleExitModal = () => {
    if (!isEdit && !isClone && builderFieldCount !== 0) {
      setExitModal(true);
    } else if (isEdit || isClone) {
      setExitModal(true);
    } else {
      navigateToWorkflow();
    }
  };

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (builderFieldCount > 0) {
        e.preventDefault();
        setExitModal(true);
        e.returnValue = "";
        e.returnValue = "";
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [builderFieldCount]);

  useEffect(() => {
    window.history.pushState(null, document.title, window.location.href);
    const handlePopState = (e) => {
      if (builderFieldCount > 0) {
        e.preventDefault();
        setExitModal(true);
        e.returnValue = "";
        e.returnValue = "";
      }
    };
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [builderFieldCount]);

  useEffect(() => {
    if (preview) {
      setIsChecked(false);
      setSelectedRadioId(null);
    }
  }, [preview]);

  useEffect(() => {
    console.log(droppedItems, "aaaa", dragItems);
  }, [droppedItems, dragItems]);

  const inputFields = elements.filter((el) =>
    ["text", "email", "number", "date", "time", "textarea"].includes(
      el.fieldType,
    ),
  );

  const findFieldByUniqueKey = (items, uniqueKey) => {
    for (const item of items || []) {
      if (item?.uniqueKey === uniqueKey) return item;
      if (
        Array.isArray(item?.radioInputValues) &&
        item.radioInputValues.length > 0
      ) {
        const nested = findFieldByUniqueKey(item.radioInputValues, uniqueKey);
        if (nested) return nested;
      }
    }
    return null;
  };

  const selectedPreviewField = preview?.uniqueKey
    ? findFieldByUniqueKey(droppedItems, preview.uniqueKey)
    : null;

  const normalizedElementSearch = elSearch.trim().toLowerCase();
  const isElementSearchActive = Boolean(normalizedElementSearch);
  // A safety checklist can use every element except the device-capture ones.
  const availableElements = isSafetyTarget
    ? elements.filter(
        (element) => !SAFETY_DISALLOWED_FIELD_TYPES.includes(element.fieldType),
      )
    : elements;
  const basicElements = availableElements.filter((element) =>
    ["text", "email", "number", "textarea"].includes(element.fieldType),
  );
  const selectionElements = availableElements.filter((element) =>
    ["radio", "checkbox", "select"].includes(element.fieldType),
  );
  const mediaElements = availableElements.filter((element) =>
    [
      "file",
      "multi_image",
      "date",
      "time",
      "scan",
      "gps",
      "ocr",
      "signal_quality",
    ].includes(element.fieldType),
  );
  const matchesElementSearch = (element) => {
    if (!normalizedElementSearch) return true;
    return `${element.fieldName || ""} ${element.fieldType || ""}`
      .toLowerCase()
      .includes(normalizedElementSearch);
  };
  const filteredBasicElements = basicElements.filter(matchesElementSearch);
  const filteredSelectionElements = selectionElements.filter(matchesElementSearch);
  const filteredMediaElements = mediaElements.filter(matchesElementSearch);
  const hasElementMatches =
    filteredBasicElements.length > 0 ||
    filteredSelectionElements.length > 0 ||
    filteredMediaElements.length > 0;
  const toggleElementCategory = (key) => {
    setCollapsedElementCats((prev) => ({ ...prev, [key]: !prev[key] }));
  };
  const shouldShowPreviewPanel = Boolean(
    selectedPreviewField &&
    (!isPageWise || Number(selectedPreviewField.page ?? 1) === Number(page)),
  );
  const elementsPanelRef = useRef(null);
  const [syncedColumnHeight, setSyncedColumnHeight] = useState(null);

  useLayoutEffect(() => {
    const node = elementsPanelRef.current;
    if (!node) return;

    const updateHeight = () => {
      const nextHeight = Math.ceil(node.getBoundingClientRect().height);
      setSyncedColumnHeight((prev) => (prev !== nextHeight ? nextHeight : prev));
    };

    updateHeight();
    const observer = new ResizeObserver(updateHeight);
    observer.observe(node);

    return () => observer.disconnect();
  }, []);

  const themeClass =
    theme === "dark" ? "dark-mode " : theme === "high-contrast" ? "high-contrast" : "";
  const checkboxClass =
    "h-4 w-4 rounded border-gray-300 text-[#236DB4] focus:ring-[#236DB4]/30 cursor-pointer";
  const checkboxLabelClass =
    "text-sm font-medium text-gray-900 dark:text-white whitespace-nowrap";

  // `maxPage` is the source of truth for page count (stable across navigation, tracks
  // empty pages too); the dragItems scan is just a safety net in case an item ever
  // carries a page number higher than maxPage got told about.
  const totalPages = Math.max(
    1,
    maxPage,
    ...dragItems
      .map((item) => Number(item?.page) || 1)
      .filter((value) => Number.isFinite(value)),
  );

  const handleAddPage = () => {
    const newPage = totalPages + 1;
    setMaxPage(newPage);
    setPage(newPage);
    toast.success(translations[langMode]?.pageAdded ?? "Page added");
  };

  const handleDuplicatePage = () => {
    const pageItems = dragItems.filter((item) => item.page === page);
    if (pageItems.length === 0) {
      toast.warn(translations[langMode].addleastonelementto);
      return;
    }

    const newPage = totalPages + 1;
    const keyMap = [];
    const cloneTree = (item) => {
      const newUniqueKey = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
      keyMap.push({ originalKey: item.uniqueKey, newKey: newUniqueKey });
      const cloned = { ...item, uniqueKey: newUniqueKey };
      if (Array.isArray(item.radioInputValues)) {
        cloned.radioInputValues = item.radioInputValues.map(cloneTree);
      }
      return cloned;
    };

    const clonedItems = pageItems.map((item) => ({ ...cloneTree(item), page: newPage }));

    const clonedRadioButtons = radioButtons
      .filter((rb) => keyMap.some((k) => k.originalKey === rb.uniqueKey))
      .map((rb) => {
        const match = keyMap.find((k) => k.originalKey === rb.uniqueKey);
        return { ...rb, uniqueKey: match.newKey, radioPage: newPage };
      });

    const renumberQueNo = (items) =>
      items.map((item, index) => ({ ...item, queNo: index + 1 }));

    setDroppedItems((prev) => renumberQueNo([...prev, ...clonedItems]));
    setDragItems((prev) => renumberQueNo([...prev, ...clonedItems]));
    if (clonedRadioButtons.length > 0) {
      setRadioButtons((prev) => [...prev, ...clonedRadioButtons]);
    }
    setMaxPage(newPage);
    setPage(newPage);
    toast.success(translations[langMode]?.pageDuplicated ?? "Page duplicated");
  };

  const handleDeletePage = () => {
    if (totalPages <= 1) {
      toast.warn(
        translations[langMode]?.workflowNeedsAtLeastOnePage ??
        "A workflow needs at least one page",
      );
      setShowDeletePageConfirm(false);
      return;
    }

    const collectNestedKeys = (item) => {
      let keys = [];
      if (item.radioInputValues) {
        for (const nested of item.radioInputValues) {
          keys.push(nested.uniqueKey);
          keys = keys.concat(collectNestedKeys(nested));
        }
      }
      return keys;
    };
    const isDeletedPageItem = (item) => item.page === page;
    const collectedKeys = [];
    dragItems.forEach((item) => {
      if (isDeletedPageItem(item)) {
        collectedKeys.push(item.uniqueKey, ...collectNestedKeys(item));
      }
    });

    const remapPage = (item) => ({
      ...item,
      page: item.page > page ? item.page - 1 : item.page,
    });
    const filterAndRenumber = (items) =>
      items
        .filter((item) => !isDeletedPageItem(item))
        .map(remapPage)
        .map((item, index) => ({ ...item, queNo: index + 1 }));

    setDroppedItems(filterAndRenumber(droppedItems));
    setDragItems(filterAndRenumber(dragItems));
    setRadioButtons((prev) => prev.filter((rb) => !collectedKeys.includes(rb.uniqueKey)));

    if (selectedPreviewField && collectedKeys.includes(selectedPreviewField.uniqueKey)) {
      setPreview({});
    }

    const wasLastPage = page === totalPages;
    setMaxPage((prev) => Math.max(1, prev - 1));
    setPage((prev) => (wasLastPage ? Math.max(1, prev - 1) : prev));
    setShowDeletePageConfirm(false);
    toast.success(translations[langMode]?.pageDeleted ?? "Page deleted");
  };

  // Moves a single field to a different page -- previously the only way to
  // get a field onto another page was to drop a new one there, or duplicate
  // the whole page; there was no way to relocate an existing field.
  const handleMoveFieldToPage = (uniqueKey, targetPage) => {
    const normalizedTarget = Number(targetPage);
    const targetItem = dragItems.find((item) => item.uniqueKey === uniqueKey);
    if (!targetItem || Number(targetItem.page) === normalizedTarget) return;

    const collectNestedKeys = (item) => {
      let keys = [];
      if (item.radioInputValues) {
        for (const nested of item.radioInputValues) {
          keys.push(nested.uniqueKey);
          keys = keys.concat(collectNestedKeys(nested));
        }
      }
      return keys;
    };
    const nestedKeys = collectNestedKeys(targetItem);

    // queNo must stay sequential *grouped by page* (1,2,3 on page 1, then
    // 4,5,6,7 on page 2, etc.), not by raw array position -- the moved item
    // keeps its old array slot (only its `page` changes), so a plain
    // index-based renumber left page 1 with 1,3,4 and page 2 with 2,5,6,7
    // until some unrelated action (e.g. handleDragStop's page-grouped
    // renumber) happened to fix it up later. Same group-by-page-then-flatten
    // approach handleDragStop/handleDeletePage already use, with the moved
    // item appended to the end of its destination page.
    const applyMove = (items) => {
      const movedItem = items.find((item) => item.uniqueKey === uniqueKey);
      if (!movedItem) return items;
      const updatedMoved = { ...movedItem, page: normalizedTarget };
      const groupedByPage = items
        .filter((item) => item.uniqueKey !== uniqueKey)
        .reduce((acc, item) => {
          if (!acc[item.page]) acc[item.page] = [];
          acc[item.page].push(item);
          return acc;
        }, {});
      groupedByPage[normalizedTarget] = [...(groupedByPage[normalizedTarget] || []), updatedMoved];

      return Object.keys(groupedByPage)
        .map(Number)
        .sort((a, b) => a - b)
        .flatMap((p) => groupedByPage[p])
        .map((item, index) => ({ ...item, queNo: index + 1 }));
    };

    setDroppedItems((prev) => applyMove(prev));
    setDragItems((prev) => applyMove(prev));

    if (nestedKeys.length > 0) {
      setRadioButtons((prev) =>
        prev.map((rb) =>
          nestedKeys.includes(rb.uniqueKey) ? { ...rb, radioPage: normalizedTarget } : rb,
        ),
      );
    }

    // Follow the field to its new page, same as handleAddPage/handleDuplicatePage
    // already jump the view to the page they just affected -- otherwise the
    // preview panel would immediately hide itself (shouldShowPreviewPanel only
    // shows a field that belongs to the page currently being viewed).
    setPage(normalizedTarget);
    toast.success(translations[langMode]?.fieldMoved ?? "Field moved");
  };

  const pageMenuItemClass = (active, danger) =>
    `flex w-full items-center gap-2.5 px-3.5 py-2 mx-1 rounded-lg text-sm font-medium text-start ${
      danger ? "text-red-600" : "text-slate-700"
    } ${active ? (danger ? "bg-red-50" : "bg-slate-50") : ""}`;

  // Moved up from DroppableArea.js so it can share one row with the page-nav controls.
  const versionsMenuButton = (
    <Menu as="div" className="relative shrink-0">
      <Menu.Button
        type="button"
        title={translations[langMode]?.versionHistory ?? "Page options"}
        className={`inline-flex h-[34px] w-[34px] items-center justify-center rounded-[9px] border border-slate-200 bg-white text-[17px] text-slate-500 transition-colors duration-150 hover:border-slate-300 hover:bg-slate-100 hover:text-slate-700 focus:border-blue-500 focus:outline-none focus:ring-blue-500 dark:focus:border-blue-500 dark:focus:ring-blue-500 ${themeClass}`}
      >
        <BsThreeDots />
      </Menu.Button>
      <Transition
        as={React.Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items
          className={`absolute z-[60] mt-1.5 w-52 rounded-xl border border-slate-100 bg-white py-1.5 shadow-xl focus:outline-none ${
            isRtl ? "left-0 origin-top-left" : "right-0 origin-top-right"
          }`}
        >
          {isPageWise && (
            <>
              <Menu.Item>
                {({ active }) => (
                  <button
                    type="button"
                    onClick={handleAddPage}
                    className={pageMenuItemClass(active)}
                    style={{ width: "calc(100% - 0.5rem)" }}
                  >
                    <Plus size={15} />
                    {translations[langMode]?.addPage ?? "Add page"}
                  </button>
                )}
              </Menu.Item>
              <Menu.Item>
                {({ active }) => (
                  <button
                    type="button"
                    onClick={handleDuplicatePage}
                    className={pageMenuItemClass(active)}
                    style={{ width: "calc(100% - 0.5rem)" }}
                  >
                    <Copy size={15} />
                    {translations[langMode]?.duplicatePage ?? "Duplicate page"}
                  </button>
                )}
              </Menu.Item>
              <div className="my-1 border-t border-slate-100" />
            </>
          )}
          <Menu.Item>
            {({ active }) => (
              <button
                type="button"
                onClick={triggerVersion}
                className={pageMenuItemClass(active)}
                style={{ width: "calc(100% - 0.5rem)" }}
              >
                <History size={15} />
                {translations[langMode]?.versionHistory ?? "Version history"}
              </button>
            )}
          </Menu.Item>
          {isPageWise && (
            <>
              <div className="my-1 border-t border-slate-100" />
              <Menu.Item>
                {({ active }) => (
                  <button
                    type="button"
                    onClick={() => setShowDeletePageConfirm(true)}
                    className={pageMenuItemClass(active, true)}
                    style={{ width: "calc(100% - 0.5rem)" }}
                  >
                    <Trash2 size={15} />
                    {translations[langMode]?.deletePage ?? "Delete page"}
                  </button>
                )}
              </Menu.Item>
            </>
          )}
        </Menu.Items>
      </Transition>
    </Menu>
  );

  return (
    <>
      <Joyride
        steps={workflowmaker}
        run={runTour}
        continuous
        showSkipButton
        showProgress
        scrollToFirstStep
        callback={handleJoyrideCallback}
        styles={{
          options: {
            arrowColor: "#fff",
            zIndex: 10000,
            overlayColor: "rgba(0, 0, 0, 0.5)",
            primaryColor: "#4C3BCF",
            textColor: "#333",
          },
          tooltip: {
            borderRadius: "10px",
          },
          buttonSkip: {
            color: "#4C3BCF",
          },
          buttonNext: {
            backgroundColor: "#4C3BCF",
          },
          buttonBack: {
            color: "#4C3BCF",
          },
        }}
      />
      <div
        className={`flex w-full flex-col ${
          theme === "dark"
            ? "dark-mode "
            : theme === "high-contrast"
              ? "high-contrast"
              : ""
        }`}
      >
          <div
            className={`mx-2 mt-2 min-w-0 shrink-0 flex flex-col gap-3 rounded-xl border border-slate-200 bg-white px-3 py-3 shadow-sm sm:mx-4 sm:mt-3 sm:px-5 sm:py-4 sm:gap-4 ${
              theme === "dark"
                ? "dark-mode "
                : theme === "high-contrast"
                  ? "high-contrast"
                  : ""
            }`}
          >
            {/* Row 1: back button + title, action-button cluster */}
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div className="-ms-4 flex items-center gap-3">
                <BackButton onClick={handleExitModal} />
                <h1 className="text-base font-bold text-slate-800 leading-tight sm:text-lg">
                  {Translations[langMode].workflow}
                </h1>
              </div>
              <div className="flex flex-wrap items-center gap-2">
                {companyStampPreview ? (
                  <CommonButton colorIntent="primary"
                    type="button"
                    onClick={() => setShowStampModal(true)}
                    variant="primary"
                    tooltipText={translations[langMode].companyStamp}
                    tooltipPosition="top"
                    className="!rounded-[9px] !gap-[7px] text-[13.5px] font-semibold"
                  >
                    <Pencil size={16} />
                    <span className="hidden max-w-[200px] truncate sm:inline">
                      {translations[langMode].changeCompanyStamp}
                    </span>
                  </CommonButton>
                ) : (
                  <CommonButton colorIntent="primary"
                    type="button"
                    onClick={() => setShowStampModal(true)}
                    variant="primary"
                    tooltipText={translations[langMode].uploadCompanyStamp}
                    tooltipPosition="top"
                    className="!rounded-[9px] !gap-[7px] text-[13.5px] font-semibold"
                  >
                    <CloudUpload size={16} />
                    <span className="hidden max-w-[200px] truncate sm:inline">
                      {translations[langMode].uploadCompanyStamp}
                    </span>
                  </CommonButton>
                )}
                <CommonButton colorIntent="primary"
                  tooltipText={translations[langMode].previewcurrentworkflowlayout}
                  tooltipPosition="top"
                  onClick={handlePreviewClick}
                  variant="primary"
                  className="!rounded-[9px] !gap-[7px] text-[13.5px] font-semibold"
                >
                  <Eye size={16} />
                  <span className="hidden sm:inline">{Translations[langMode].preview}</span>
                </CommonButton>
                {/* On the safety tab in edit mode the child has its own CRUD, so the
                    main workflow's Update button is deliberately not shown here --
                    a click should never be ambiguous about which row it writes. */}
                {isSafetyTarget && isEdit ? (
                  safetyWorkflowId ? (
                    <>
                      <CommonButton colorIntent="success"
                        type="button"
                        onClick={handleUpdateSafetyWorkflowClick}
                        variant="primary"
                        tooltipText={
                          translations[langMode].updateSafetyChecklistTooltip ??
                          "Save changes to the safety checklist only"
                        }
                        tooltipPosition="top"
                        className="!rounded-[9px] !gap-[7px] text-[13.5px] font-semibold"
                      >
                        <Check size={16} />
                        {translations[langMode].updateSafetyChecklist ??
                          "Update Safety Checklist"}
                      </CommonButton>
                      <CommonButton colorIntent="danger"
                        type="button"
                        onClick={() => setShowDeleteSafetyConfirm(true)}
                        variant="danger"
                        tooltipText={
                          translations[langMode].deleteSafetyChecklistTooltip ??
                          "Disable safety compliance and save the workflow before deleting"
                        }
                        tooltipPosition="top"
                        className="!rounded-[9px] !gap-[7px] text-[13.5px] font-semibold"
                      >
                        <Trash2 size={16} />
                        {translations[langMode].deleteSafetyChecklist ??
                          "Delete Safety Checklist"}
                      </CommonButton>
                    </>
                  ) : (
                    <CommonButton colorIntent="success"
                      type="button"
                      onClick={handleCreateSafetyWorkflowClick}
                      variant="success"
                      tooltipText={
                        translations[langMode].createSafetyChecklistTooltip ??
                        "Create the safety checklist under this workflow"
                      }
                      tooltipPosition="top"
                      className="!rounded-[9px] !gap-[7px] text-[13.5px] font-semibold"
                    >
                      <Plus size={16} />
                      {translations[langMode].createSafetyChecklist ??
                        "Create Safety Checklist"}
                    </CommonButton>
                  )
                ) : isClone ? (
                  <CommonButton colorIntent="success"
                    onClick={handleCloneClick}
                    variant="success"
                    tooltipText={translations[langMode].plzmakesuretosetauique}
                    tooltipPosition="top"
                    className="!rounded-[9px] !gap-[7px] text-[13.5px] font-semibold"
                  >
                    <Check size={16} />
                    {Translations[langMode].clone}
                  </CommonButton>
                ) : workflowFields && workflowFields?.length > 0 ? (
                  <CommonButton colorIntent="success"
                    tooltipText={translations[langMode].updatetheworkflowiwth}
                    tooltipPosition="top"
                    onClick={workflowUpdate}
                    variant="primary"
                    className="!rounded-[9px] !gap-[7px] text-[13.5px] font-semibold"
                  >
                    <Check size={16} />
                    {Translations[langMode].update}
                  </CommonButton>
                ) : (
                  <CommonButton colorIntent="success"
                    type="button"
                    onClick={workflowSubmit}
                    // disabled={!reportField}
                    variant="primary"
                    tooltipText={
                      !reportField
                        ? translations[langMode].pleaseselectatleastonefild
                        : translations[langMode].submitworkflow
                    }
                    tooltipPosition="top"
                    className="!rounded-[9px] !gap-[7px] text-[13.5px] font-semibold"
                  >
                    <Check size={16} />
                    {Translations[langMode].Submit}
                  </CommonButton>
                )}
              </div>
            </div>

            {/* Row 2: workflow summary + settings toggle */}
            <div className="flex flex-wrap items-center justify-between gap-3 border-t border-slate-100 pt-3">
              <div className="flex min-w-0 flex-wrap items-center gap-2">
                <span
                  className="inline-block max-w-[220px] truncate text-[13.5px] font-bold text-slate-800 sm:max-w-[380px] lg:max-w-[560px]"
                  title={workflowName || Translations[langMode].entername}
                >
                  {workflowName || Translations[langMode].entername}
                </span>
                <span className="text-slate-300">&middot;</span>
                <span className="truncate text-[12.5px] text-slate-500">
                  {Translations[langMode].pdf}: {title || Translations[langMode].enterPDFTitle}
                </span>
                <span className="text-slate-300">&middot;</span>
                <span className="text-[12.5px] text-slate-500">
                  {translations[langMode]?.timerLabel ?? "Timer"}: {selectedTimer}{" "}
                  {translations[langMode]?.secondsUnit ?? "sec"}
                </span>
                <span
                  className={`rounded-full px-[9px] py-[3px] text-[10.5px] font-bold tracking-[0.02em] ${
                    isPageWise ? "bg-[#EAF3FB] text-[#236DB4]" : "bg-slate-100 text-slate-400"
                  }`}
                >
                  {isPageWise
                    ? translations[langMode].isPageWise
                    : translations[langMode]?.pageWiseOff ?? "Page wise off"}
                </span>
              </div>
              <div className="flex shrink-0 flex-wrap items-center gap-2">
                {/* Which form the canvas below is editing: the workflow itself, or its
                    safety-compliance sub-workflow. Both share this one builder. */}
                {isSafetyComplianceRequired && (
                  <div className="inline-flex h-[30px] items-center rounded-lg border border-slate-200 bg-slate-50 p-[2px]">
                    <button
                      type="button"
                      onClick={() => handleBuilderTargetChange("main")}
                      className={`inline-flex h-[26px] items-center gap-1.5 rounded-[7px] px-3 text-xs font-semibold transition-colors ${
                        isSafetyTarget
                          ? "text-slate-500 hover:text-slate-700"
                          : "bg-white text-[#236DB4] shadow-sm"
                      }`}
                    >
                      {translations[langMode].mainWorkflowTab ?? "Main workflow"}
                    </button>
                    <button
                      type="button"
                      onClick={() => handleBuilderTargetChange("safety")}
                      className={`inline-flex h-[26px] items-center gap-1.5 rounded-[7px] px-3 text-xs font-semibold transition-colors ${
                        isSafetyTarget
                          ? "bg-white text-[#236DB4] shadow-sm"
                          : "text-slate-500 hover:text-slate-700"
                      }`}
                    >
                      <ShieldCheck size={13} />
                      {translations[langMode].safetyChecklistTab ??
                        "Safety checklist"}
                      <span
                        className={`rounded-full px-[6px] py-[1px] text-[10px] font-bold ${
                          isSafetyTarget
                            ? "bg-[#EAF3FB] text-[#236DB4]"
                            : "bg-slate-200 text-slate-500"
                        }`}
                      >
                        {safetyDroppedItems.length}
                      </span>
                      {/* In edit mode the child is a real row, so say whether it
                          exists yet -- that's what decides Create vs Update. */}
                      {isEdit && (
                        <span
                          className={`rounded-full px-[6px] py-[1px] text-[10px] font-bold ${
                            safetyWorkflowId
                              ? "bg-[#E8F7EF] text-[#1B7F4B]"
                              : "bg-amber-100 text-amber-700"
                          }`}
                        >
                          {safetyWorkflowId
                            ? translations[langMode].savedLabel ?? "Saved"
                            : translations[langMode].notCreatedLabel ??
                              "Not created"}
                        </span>
                      )}
                    </button>
                  </div>
                )}
                <button
                  type="button"
                  onClick={() => setSettingsOpen((prev) => !prev)}
                  className={`inline-flex h-[30px] shrink-0 items-center gap-1.5 rounded-lg border px-3 text-xs font-semibold transition-colors ${
                    settingsOpen
                      ? "border-[#BEDAF0] bg-[#EAF3FB] text-[#236DB4]"
                      : "border-slate-200 bg-white text-slate-600 hover:bg-slate-50"
                  }`}
                >
                  {translations[langMode]?.workflowSettings ?? "Workflow settings"}
                  <ChevronDown
                    size={14}
                    className={`transition-transform duration-150 ${settingsOpen ? "rotate-180" : ""}`}
                  />
                </button>
              </div>
            </div>

            {/* Row 3: collapsible settings panel */}
            {settingsOpen && (
              <div className="flex flex-col gap-4 border-t border-slate-100 pt-3 sm:flex-row sm:flex-wrap sm:items-end">
                <CloneOption
                  isClone={isClone}
                  isEdit={isEdit}
                  langMode={langMode}
                  theme={theme}
                  workflowName={workflowName}
                  maxAllowedAccuracy={maxAllowedAccuracy} // update by harshit
                  handleMaxAllowedAccuracyChangee={handleMaxAllowedAccuracyChangee} // update by harshit
                  title={title}
                  handleChangee={handleChangee}
                  titleHandle={titleHandle}
                  handleTimer={handleTimer}
                  selectedTimer={selectedTimer}
                  timerValue={timerValue}
                  Translations={Translations}
                  isSafetyComplianceRequired={isSafetyComplianceRequired}
                  safetyWorkflowName={safetyWorkflowName}
                  handleSafetyWorkflowNameChange={handleSafetyWorkflowNameChange}
                />
                <div className="flex flex-wrap items-center gap-x-5 gap-y-3 py-2">
                  <div className="flex items-center gap-2">
                    <input
                      id="isPageWise"
                      type="checkbox"
                      checked={Boolean(isPageWise)}
                      onChange={handleIsPageWiseChange}
                      className={`${checkboxClass} ${themeClass}`}
                    />
                    <span className={checkboxLabelClass}>
                      {translations[langMode].isPageWise}
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <input
                      id="accountProtectionCheck"
                      type="checkbox"
                      checked={Boolean(accountProtection)}
                      onChange={handleCheckAccountProtection}
                      className={`${checkboxClass} ${themeClass}`}
                    />
                    <span className={checkboxLabelClass}>
                      {translations[langMode].accountProtection}
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <input
                      id="clockin"
                      type="checkbox"
                      checked={selectedOption === "clockin"}
                      onChange={() => handleOptionChange({ target: { value: "clockin" } })}
                      className={`${checkboxClass} ${themeClass}`}
                    />
                    <span className={checkboxLabelClass}>
                      {translations[langMode].clockIn}
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <input
                      id="clockout"
                      type="checkbox"
                      checked={selectedOption === "clockout"}
                      onChange={() => handleOptionChange({ target: { value: "clockout" } })}
                      className={`${checkboxClass} ${themeClass}`}
                    />
                    <span className={checkboxLabelClass}>
                      {translations[langMode].clockOut}
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <input
                      id="isReviewEnabled"
                      type="checkbox"
                      checked={Boolean(isReviewEnabled)}
                      onChange={handleIsReviewEnabledChange}
                      className={`${checkboxClass} ${themeClass}`}
                    />
                    <span className={checkboxLabelClass}>
                      {translations[langMode].isReviewEnabled}
                    </span>
                  </div>
                  <div className="flex items-center gap-1">
                    <input
                      id="isSafetyComplianceRequired"
                      type="checkbox"
                      checked={Boolean(isSafetyComplianceRequired)}
                      onChange={handleSafetyComplianceChange}
                      className={`${checkboxClass} ${themeClass}`}
                    />
                    <span className={`${checkboxLabelClass} ms-1`}>
                      {translations[langMode].safetyComplianceRequired ??
                        "Needs Safety Checklist"}
                    </span>
                    <FieldInfoIcon
                      className="field-info-icon--wrap" blueTooltip
                      tooltipText={
                        translations[langMode].safetyComplianceRequiredTooltip ??
                        "When enabled, a safety-compliance sub-workflow is built under this workflow. Barcode, OCR, GPS and Capture Signal Quality fields are not available in it."
                      }
                    />
                  </div>
                  <div className="flex items-center gap-1">
                    <input
                      id="isShowDistance"
                      type="checkbox"
                      checked={Boolean(isShowDistance)}
                      onChange={handleIsShowDistanceChange}
                      className={`${checkboxClass} ${themeClass}`}
                    />
                    <span className={checkboxLabelClass}>
                      {translations[langMode].isShowDistance ?? "Show Coordinate Distance"}
                    </span>
                    <FieldInfoIcon
                      className="field-info-icon--wrap" blueTooltip
                      tooltipText={
                        translations[langMode].isShowDistanceTooltip ??
                        "When enabled, the report and PDF export display the distance between the uploaded task coordinates and the coordinates captured at field submission."
                      }
                    />
                    {isEdit && (
                      <div className="ms-2 flex items-center gap-2 border-s border-slate-200 ps-2">
                        <ActionIconButton
                          onClick={handleGetfields}
                          tone="gray"
                          className="!border !border-[#236DB4] !bg-[#236DB4] !text-white shadow-sm hover:!border-[#1d5a96] hover:!bg-[#1d5a96]"
                          ariaLabel={translations[langMode]?.wfAddFieldsForReport ?? "Add Fields For Report"}
                          tooltipText={translations[langMode]?.wfAddFieldsForReport ?? "Add Fields For Report"}
                          tooltipPosition="top"
                        >
                          <Plus size={16} />
                        </ActionIconButton>
                        {manfields && (
                          <ActionIconButton
                            onClick={handlefields}
                            tone="gray"
                            className="!border !border-[#236DB4] !bg-[#236DB4] !text-white shadow-sm hover:!border-[#1d5a96] hover:!bg-[#1d5a96]"
                            ariaLabel={translations[langMode]?.wfSelectMandatoryField ?? "Select Mandatory Field"}
                            tooltipText={translations[langMode]?.wfSelectMandatoryField ?? "Select Mandatory Field"}
                            tooltipPosition="top"
                          >
                            <FileCheck2 size={16} />
                          </ActionIconButton>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
          <GetFieldFolder
            open={open}
            setOpen={setOpen}
            fields={fields}
            setFields={setFields}
            taskExcelColumns={taskExcelColumns}
            setTaskExcelColumns={setTaskExcelColumns}
          />
          <MandatoryField
            open={manopen}
            setOpen={setManOpen}
            manfields={manfields}
            setManFields={setManFields}
          />
          <DndProvider backend={HTML5Backend}>
            <div
              className={`mx-2 mb-2 mt-2 grid min-h-0 flex-grow gap-3 overflow-x-auto overflow-y-hidden lg:overflow-hidden sm:mx-4 sm:mb-3 sm:mt-3 ${
                shouldShowPreviewPanel
                  ? "grid-cols-[264px_minmax(520px,1fr)_344px]"
                  : "grid-cols-[264px_minmax(520px,1fr)]"
              }`}
            >
              <div
                ref={elementsPanelRef}
                className={`min-w-0 h-fit self-start rounded-lg border border-slate-200 bg-white px-3 pt-3 pb-1.5 shadow-sm ${
                  theme === "dark"
                    ? "dark-mode "
                    : theme === "high-contrast"
                      ? "high-contrast"
                      : ""
                }`}
              >
                {mainTab === 1 && (
                  <React.Fragment>
                    <div className="mb-3 border-b border-slate-200 pb-3">
                      <h2 className="text-[13.5px] font-bold text-slate-800">
                        {Translations[langMode].element || "Elements"}
                      </h2>
                      <p className="mt-0.5 text-[11px] font-medium text-slate-400">
                        {translations[langMode]?.dragFieldToCanvas ?? "Drag a field onto the canvas"}
                      </p>
                      {isSafetyTarget && (
                        <p className="mt-2 flex items-start gap-1.5 rounded-md bg-[#EAF3FB] px-2 py-1.5 text-[11px] font-medium leading-4 text-[#236DB4]">
                          <ShieldCheck size={13} className="mt-[1px] shrink-0" />
                          {translations[langMode].safetyPaletteRestricted ??
                            "Barcode, OCR, GPS and Capture Signal Quality aren't available in a safety checklist."}
                        </p>
                      )}
                    </div>
                    <div className="relative mb-3">
                      <Search
                        size={15}
                        className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
                      />
                      <input
                        type="text"
                        value={elSearch}
                        onChange={(event) => setElSearch(event.target.value)}
                        placeholder={translations[langMode]?.searchField ?? "Search fields..."}
                        className="h-9 w-full rounded-lg border border-slate-200 bg-slate-50 pl-9 pr-3 text-[13px] text-slate-700 outline-none transition-colors focus:border-[#236DB4] focus:bg-white focus:ring-2 focus:ring-[#EAF3FB]"
                      />
                    </div>
                    <div className={`${openTab === 1 ? "block" : "hidden"}`}>
                      {filteredBasicElements.length > 0 && (
                        <div className="mb-1">
                          <button
                            type="button"
                            onClick={() => toggleElementCategory("basic")}
                            className="mb-1 flex w-full items-center justify-between rounded-md px-1 py-1 text-[10.5px] font-bold uppercase tracking-[0.09em] text-slate-400 hover:bg-slate-50"
                          >
                            <span>{translations[langMode].basicField}</span>
                            <ChevronDown
                              size={14}
                              className={`transition-transform duration-150 ${
                                collapsedElementCats.basic && !isElementSearchActive
                                  ? "-rotate-90"
                                  : "rotate-0"
                              }`}
                            />
                          </button>
                          {(!collapsedElementCats.basic || isElementSearchActive) &&
                            filteredBasicElements.map((element) => (
                              <DraggableElement
                                key={element.fieldName}
                              {...element}
                              elementCategory="basic"
                              isNewFieldDragged={isNewFieldDragged}
                              setIsNewFieldDragged={setIsNewFieldDragged}
                              validationValues={validationFormValues}
                                setSelectedRadioId={setSelectedRadioId}
                                setCollapse={setCollapse}
                              />
                            ))}
                        </div>
                      )}

                      {filteredSelectionElements.length > 0 && (
                        <div className="mb-1 mt-2">
                          <button
                            type="button"
                            onClick={() => toggleElementCategory("selection")}
                            className="mb-1 flex w-full items-center justify-between rounded-md px-1 py-1 text-[10.5px] font-bold uppercase tracking-[0.09em] text-slate-400 hover:bg-slate-50"
                          >
                            <span>{translations[langMode].selectionfield}</span>
                            <ChevronDown
                              size={14}
                              className={`transition-transform duration-150 ${
                                collapsedElementCats.selection && !isElementSearchActive
                                  ? "-rotate-90"
                                  : "rotate-0"
                              }`}
                            />
                          </button>
                          {(!collapsedElementCats.selection || isElementSearchActive) &&
                            filteredSelectionElements.map((element) => (
                              <DraggableElement
                                key={element.fieldName}
                                {...element}
                                elementCategory="selection"
                                isNewFieldDragged={isNewFieldDragged}
                                setIsNewFieldDragged={setIsNewFieldDragged}
                                validationValues={validationFormValues}
                                setSelectedRadioId={setSelectedRadioId}
                                setCollapse={setCollapse}
                              />
                            ))}
                        </div>
                      )}

                      {filteredMediaElements.length > 0 && (
                        <div className="mb-1 mt-2">
                          <button
                            type="button"
                            onClick={() => toggleElementCategory("media")}
                            className="mb-1 flex w-full items-center justify-between rounded-md px-1 py-1 text-[10.5px] font-bold uppercase tracking-[0.09em] text-slate-400 hover:bg-slate-50"
                          >
                            <span>{translations[langMode].mediafield}</span>
                            <ChevronDown
                              size={14}
                              className={`transition-transform duration-150 ${
                                collapsedElementCats.media && !isElementSearchActive
                                  ? "-rotate-90"
                                  : "rotate-0"
                              }`}
                            />
                          </button>
                          {(!collapsedElementCats.media || isElementSearchActive) &&
                            filteredMediaElements.map((element) => (
                              <DraggableElement
                                key={element.fieldName}
                                {...element}
                                elementCategory="media"
                                isNewFieldDragged={isNewFieldDragged}
                                setIsNewFieldDragged={setIsNewFieldDragged}
                                validationValues={validationFormValues}
                                setSelectedRadioId={setSelectedRadioId}
                                setCollapse={setCollapse}
                              />
                            ))}
                        </div>
                      )}

                      {!hasElementMatches && (
                        <div className="rounded-lg border border-slate-200 bg-slate-50 p-3 text-center text-[12.5px] text-slate-500">
                          No fields match "{elSearch}".
                        </div>
                      )}
                    </div>
                  </React.Fragment>
                )}
              </div>
              <div
                className={`flex min-w-0 flex-col gap-1 overflow-hidden`}
                style={syncedColumnHeight ? { height: `${syncedColumnHeight}px` } : undefined}
              >
                <div className="rounded-lg border border-slate-200 bg-white px-3 py-2 shadow-sm">
                  {isPageWise ? (
                    <DynamicPage
                      page={page}
                      setPage={setPage}
                      dragItems={dragItems}
                      totalPages={totalPages}
                      trailingSlot={versionsMenuButton}
                    />
                  ) : (
                    <div className="flex items-center justify-end">{versionsMenuButton}</div>
                  )}
                </div>
                <div className="min-h-0 flex-1 overflow-hidden">
                  <DroppableArea
                    // Remounting per target keeps the canvas' own drag/drop closures
                    // (and its internal selection state) bound to the right setters.
                    key={isSafetyTarget ? "safety" : "main"}
                    disallowedFieldTypes={
                      isSafetyTarget
                        ? SAFETY_DISALLOWED_FIELD_TYPES
                        : NO_DISALLOWED_FIELD_TYPES
                    }
                    setPdfInput={setPdfInput}
                    setDroppedItems={setDroppedItems}
                    droppedItems={droppedItems}
                    mainTab={mainTab}
                    setMainTab={setMainTab}
                    savedItems={savedItems}
                    setPreview={setPreview}
                    preview={preview}
                    setDragItems={setDragItems}
                    dragItems={dragItems}
                    handleRemoveInput={handleRemoveInput}
                    setreportInput={setreportInput}
                    setreportField={setreportField}
                    setShowInput={setShowInput}
                    setShowRadioOptions={setShowRadioOptions}
                    setSelectedRadioOption={setSelectedRadioOption}
                    setRadioButtons={setRadioButtons}
                    radioButtons={radioButtons}
                    page={page}
                    isPageWise={isPageWise}
                    isNewFieldDragged={isNewFieldDragged}
                    setIsNewFieldDragged={setIsNewFieldDragged}
                    setSelectedRadioId={setSelectedRadioId}
                    setCollapse={setCollapse}
                    setCollapsedGroups={setCollapsedGroups}
                    setPdfIcon={setPdfIcon}
                    setReportIcon={setReportIcon}
                    reportInput={reportInput}
                    pdfInput={pdfInput}
                    isEdit={isEdit}
                    isClone={isClone}
                  />
                </div>
              </div>
              {shouldShowPreviewPanel && (
                <div
                  className={`min-w-0 min-h-0 overflow-hidden ${
                    theme === "dark"
                      ? "dark-mode "
                      : theme === "high-contrast"
                        ? "high-contrast"
                        : ""
                  }`}
                  style={syncedColumnHeight ? { height: `${syncedColumnHeight}px` } : undefined}
                >
                  <div className="h-full min-h-0 overflow-y-auto pr-1">
                    {showVersions && (
                      <WorkflowVersions
                        workflowId={workflowId}
                        hasMore={hasMore}
                        setHasMore={setHasMore}
                        loading={loading}
                        setLoading={setLoading}
                        pages={pages}
                        setPages={setPages}
                        handleVersionClick={handleVersionClick}
                        workflowHistories={workflowVersionHistories}
                      />
                    )}
                    {selectedPreviewField && (
                      <FieldDetails
                        handleValidationDelete={handleValidationDelete}
                        updateValidationField={updateValidationField}
                        preview={selectedPreviewField}
                        setPreview={setPreview}
                        setDroppedItems={setDroppedItems}
                        droppedItems={droppedItems}
                        setDragItems={setDragItems}
                        dragItems={dragItems}
                        theme={theme}
                        isEdit={isEdit}
                        isClone={isClone}
                        langMode={langMode}
                        isPageWise={isPageWise}
                        totalPages={totalPages}
                        onMoveFieldToPage={handleMoveFieldToPage}
                        handleCloneElement={handleCloneElement}
                        handleRemoveElement={handleRemoveElement}
                        handleInputChange={handleInputChange}
                        handleToggleChange={handleToggleChange}
                        pdfMandatory={pdfMandatory}
                        handlePdfInput={handlePdfInput}
                        addPdffield={addPdffield}
                        pdfInput={pdfInput}
                        setPdfInput={setPdfInput}
                        setreportInput={setreportInput}
                        showInput={showInput}
                        reportMandatory={reportMandatory}
                        reportField={reportField}
                        reportInput={reportInput}
                        handleReportInput={handleReportInput}
                        addReportfield={addReportfield}
                        Translations={Translations}
                        shouldRenderSelectOption={shouldRenderSelectOption}
                        groupedRadioButtons={groupedRadioButtons}
                        collapse={collapse}
                        collapsedGroups={collapsedGroups}
                        toggleCollapse={toggleCollapse}
                        selectedRadioId={selectedRadioId}
                        handleRadioBtnBelongs={handleRadioBtnBelongs}
                        setSelectedRadioId={setSelectedRadioId}
                        shouldRenderSelectOptionEdit={
                          shouldRenderSelectOptionEdit
                        }
                        isEditShow={isEditShow}
                        setIsEditShow={setIsEditShow}
                        radioButtons={radioButtons}
                        tempEditValues={tempEditValues}
                        setTempEditValues={setTempEditValues}
                        handleRadioOptions={handleRadioOptions}
                        handleRadioDeleteOptions={handleRadioDeleteOptions}
                        isNewFieldDragged={isNewFieldDragged}
                        displaySelectedValue={displaySelectedValue}
                        question={question}
                        inputValues={inputValues}
                        tempInputValue={tempInputValue}
                        setTempInputValue={setTempInputValue}
                        handleAddInput={handleAddInput}
                        handleRemoveInput={handleRemoveInput}
                        toast={toast}
                        setCurrentValidation={setCurrentValidation}
                        setValidationModal={setValidationModal}
                        setValidationId={setValidationId}
                        validationId={validationId}
                        validationFormValues={validationFormValues}
                        setValidationFormValues={setValidationFormValues}
                        setCompareValidationModal={setCompareValidationModal}
                        setIsChecked={setIsChecked}
                        getHeadline={getHeadline}
                        setPdfIcon={setPdfIcon}
                        pdficon={pdficon}
                        setReportIcon={setReportIcon}
                        reporticon={reporticon}
                        handleOptionShowToggle={handleOptionShowToggle}
                        handleAllowGalleryToggle={handleAllowGalleryToggle}
                        handlePhotoConstraintChange={handlePhotoConstraintChange}
                        aspectRatios={ASPECT_RATIOS}
                        linkedWorkflowOptions={linkedWorkflowOptions}
                        linkedWorkflowsLoading={linkedWorkflowsLoading}
                        onLinkedWorkflowChange={handleLinkedWorkflowChange}
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
          </DndProvider>
          {validationModal && (
            <ValidationModal
              onCloseValidation={onCloseValidation}
              handleCreateValidation={handleCreateValidation}
              setCurrentValidation={setCurrentValidation}
              currentValidation={currentValidation}
              validationFormValues={validationFormValues}
              setValidationFormValues={setValidationFormValues}
              previewKey={preview.uniqueKey}
              handleValidationDelete={handleValidationDelete}
            />
          )}

          {compareValidationModal &&
            selectedPreviewField &&
            isCompareEligibleField(selectedPreviewField) && (
            <CompareValidationModal
              onClose={() => setCompareValidationModal(false)}
              preview={selectedPreviewField}
              droppedItems={droppedItems}
              onSaveCompareValidation={handleSaveCompareValidation}
              onDeleteCompareValidation={handleCompareValidationDelete}
            />
          )}

        {isModalOpen && workflowPreviewData && (
          <Modal
            onClose={handleCloseModal}
            previewData={workflowPreviewData}
            page={page}
            isPageWise={isPageWise}
            linkedWorkflowOptions={linkedWorkflowOptions}
          />
        )}

        {showDeletePageConfirm && (
          <DeletePermission
            onClose={() => setShowDeletePageConfirm(false)}
            deleteFunction={handleDeletePage}
            onDeleteText={
              translations[langMode]?.confirmDeletePageText ??
              "This page and all its fields will be permanently removed. This can't be undone."
            }
          />
        )}

        {showDeleteSafetyConfirm && (
          <DeletePermission
            onClose={() => setShowDeleteSafetyConfirm(false)}
            deleteFunction={handleDeleteSafetyWorkflowClick}
            onDeleteText={
              translations[langMode].confirmDeleteSafetyChecklist ??
              "This safety checklist and all its fields will be permanently removed. Disable safety compliance and save the workflow first."
            }
          />
        )}

        {exitModal && (
          <ExitModal
            setExitModal={setExitModal}
            exitModal={exitModal}
            navigateToWorkflow={navigateToWorkflow}
            showMsg={translations[langMode].Deleteworkflowmsg}
            cancel_btn={translations[langMode].cancle}
            save_btn={translations[langMode].Yes}
            onCancel={() => setExitModal(false)}
          />
        )}

        {showStampModal && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4"
            onClick={() => setShowStampModal(false)}
          >
            <div
              className="relative w-full max-w-md transform rounded-2xl bg-white shadow-xl transition-all"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex items-center justify-between border-b px-5 py-3">
                <div className="flex items-center gap-2">
                  <h3 className="text-lg font-bold text-gray-900">
                    {translations[langMode].companyStamp}
                  </h3>
                  <FieldInfoIcon
                    tooltipText={
                      translations[langMode].companyStampDescription ??
                      "Upload a clean company stamp image for field agent documents."
                    }
                  />
                </div>
                <button
                  type="button"
                  onClick={() => setShowStampModal(false)}
                  aria-label="Close modal"
                  className="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-slate-200/80 bg-white/70 p-0 text-slate-500 transition-colors hover:border-red-200 hover:bg-red-50 hover:text-red-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#236DB4]/30"
                >
                  <X size={20} />
                </button>
              </div>

              <div className="px-5 py-6">
                <p className="mb-4 text-sm text-gray-500">
                  {translations[langMode].companyStampDescription ??
                    "Upload a clean company stamp image for field agent documents."}
                </p>

                {/* Single hidden input reused by the dropzone and the footer buttons. */}
                <input
                  id="companyStamp"
                  type="file"
                  accept="image/png,image/jpeg,image/jpg,image/svg+xml"
                  onChange={handleCompanyStampChange}
                  className="hidden"
                />

                {companyStampPreview ? (
                  <div className="flex flex-col items-center justify-center gap-3 rounded-xl border-2 border-dashed border-blue-200 bg-white p-5">
                    <img
                      src={companyStampPreview}
                      alt={translations[langMode].companyStamp}
                      className="max-h-[25vh] h-[25vh] max-w-full rounded-md object-contain"
                    />
                  </div>
                ) : (
                  <label
                    htmlFor="companyStamp"
                    className="flex cursor-pointer flex-col items-center justify-center gap-2 rounded-xl border-2 border-dashed border-blue-200 bg-white p-10 text-center hover:bg-blue-50/40"
                  >
                    <span className="mb-1 flex h-14 w-14 items-center justify-center rounded-full bg-blue-100 text-[#1d5a95]">
                      <CloudUpload size={26} />
                    </span>
                    <span className="text-base font-semibold text-gray-900">
                      {translations[langMode].uploadCompanyStamp}
                    </span>
                    <span className="text-sm text-gray-500">
                      {translations[langMode].companyStampSupported ??
                        "JPG, PNG supported"}
                    </span>
                    <span className="text-xs text-gray-400">
                      {translations[langMode].companyStampMaxSize ??
                        "Max file size: 5MB"}
                    </span>
                  </label>
                )}
              </div>

              <div className="flex justify-end gap-3 border-t px-5 py-4">
                {companyStampPreview ? (
                  <>
                    <CommonButton colorIntent="danger"
                      onClick={handleRemoveCompanyStamp}
                      variant="danger"
                      tooltipText={translations[langMode].removeCompanyStamp}
                      tooltipPosition="top"
                      className="shadow-sm transition hover:scale-105"
                    >
                      {translations[langMode].removeCompanyStamp}
                    </CommonButton>
                    <CommonButton colorIntent="primary"
                      onClick={() =>
                        document.getElementById("companyStamp")?.click()
                      }
                      variant="primary"
                      tooltipText={translations[langMode].changeCompanyStamp}
                      tooltipPosition="top"
                      className="shadow-sm transition hover:scale-105"
                    >
                      {translations[langMode].editCompanyStamp}
                    </CommonButton>
                  </>
                ) : (
                  <CommonButton colorIntent="primary"
                    onClick={() =>
                      document.getElementById("companyStamp")?.click()
                    }
                    variant="primary"
                    tooltipText={translations[langMode].uploadCompanyStamp}
                    tooltipPosition="top"
                    className="shadow-sm transition hover:scale-105"
                  >
                    {translations[langMode].chooseCompanyStamp ?? "Choose Stamp"}
                  </CommonButton>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
      {loading && <Spinner />}
    </>
  );
};

export default DynamicWorkFlow;
